webpackJsonp([1],{

/***/ "0fkY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "67IX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BpBR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EUPG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GT0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3395e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("0fkY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dc8f292","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("ZQhR")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3190bf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("QkI9")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-3190bf5a"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772adcfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WN8W")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-772adcfe"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba2690a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("NZMO")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-ba2690a0"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a441386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("oPvi")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0d9e23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("i9d8")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd022a4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("uDJ7")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: []
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36923708","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("eJtY")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b6e97a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("Pg37")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48277a17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("EUPG")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32b1d271","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("67IX")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d3008a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("U2l4")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e5c2ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("V6ic")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f72b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745923cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("pXbK")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22bcc19e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("Zf2O")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10484467","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("S4/L")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-10484467"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c172f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("GT0P")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94cb9f4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("BpBR")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2b54d16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("tGyY")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Olympic Review - Issue 116",
  "shortTitle": "OR 116",
  "description": "",
  "width": 727,
  "height": 900,
  "currentLanguage": "EN",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "https://olympicreview.touchlines.com/116/"
  }, {
    "code": "FR",
    "text": "French",
    "href": "https://revueolympique.touchlines.com/116/"
  }, {
    "code": "JP",
    "text": "Japan",
    "href": "https://olympicreview.touchlines.com/tokyo2020/"
  }],
  "basePath": "/116",
  // "basePath": "",
  "companyLogo": "logo.png",
  "publishURL": "https://olympicreview.touchlines.com/116/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": true,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {}
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 1-title\" style=\"top:4px;left:0px\" src=\"/116/static/_content/1-title-1.png\">\n        <img class=\"halfScale 1-title\" style=\"top:156px;left:258px\" src=\"/116/static/_content/1-title-2.png\">\n        <img class=\"halfScale 1-title\" style=\"top:164px;left:537px\" src=\"/116/static/_content/1-title-3.png\">\n        \n        <img class=\"halfScale 1-sub\" style=\"top:229px;left:152px\" src=\"/116/static/_content/1-sub-1.png\">\n        <img class=\"halfScale 1-sub\" style=\"top:288px;left:197px\" src=\"/116/static/_content/1-sub-2.png\">\n\n        <img class=\"halfScale 1-logo\" \" style=\"top:840px;left:15px\" src=\"/116/static/_content/1-logo-1.png\">\n        <div class=\"addContentLink\" style=\"top: 869px;left: 635px;height: 16px;width: 78px;\">\n          <a href=\"http://www.olympic.org/en\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.staggerFromTo(cOf(\"1-title\"), 0.6, {opacity:0, y:60},{opacity:1, y:0, ease: Power2.easeOut}, 0.1, 1)\n          .staggerFromTo(cOf(\"1-sub\"), 0.6, {opacity:0, x:80},{opacity:1, x:0, ease: Power2.easeOut}, 0.1, \"-=0.3\")\n          .fromTo(cOf(\"1-logo\"), 0.6, {opacity:0, y:80},{opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Olympic Official Publication of the Olympic Movement  REVIEW  June 2021 Number 116  #StrongerTogether The Olympic Games Tokyo 2020 are set to unite the world through sport after a year like no other  Athletes document the challenges they have faced on their interrupted journey to the Olympic Games Guide to the sports and venues that will take centre stage in the host city from 23 July to 8 August 2021 Postponement lessons learned and how the Olympic Movement is creating positive solutions  olympics.com"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 4-title\" style=\"top:115px;left:44px\" src=\"/116/static/_content/4-title-1.png\">\n\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(7)\" style=\"top: 369px; left: 48px; height: 102px; width: 92px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(8)\" style=\"top: 719px; left: 48px; height: 105px; width: 132px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(18)\" style=\"top: 388px; left: 215px; height: 125px; width: 132px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(20)\" style=\"top: 732px; left: 215px; height: 130px; width: 135px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(40)\" style=\"top: 342px; left: 386px; height: 118px; width: 215px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(60)\" style=\"top: 712px; left: 386px; height: 95px; width: 205px;\"></div>\n        ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.staggerFromTo(cOf(\"4-title\"), 0.6, {opacity:0, y:60},{opacity:1, y:0, ease: Power2.easeOut}, 0.1, 1)\n          .staggerFromTo(cOf(\"4-sub\"), 0.6, {opacity:0, x:80},{opacity:1, x:0, ease: Power2.easeOut}, 0.1, \"-=0.3\")\n          .fromTo(cOf(\"4-logo\"), 0.6, {opacity:0, y:80},{opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "4  Contents  CONTENTS  OFFICIAL PUBLICATION OF THE OLYMPIC MOVEMENT JUNE 2021  7  FOREWORD  By IOC President Thomas Bach.  18  BEYOND THE RINGS  40  TOKYO 2020 PREVIEW  Olympic Review looks at how organisers are planning to deliver a safe and secure Olympic Games, and provides a comprehensive guide to the sports and the venues.  Tokyo 2020 Sports Director Kotani Mikako looks ahead to this summer’s Olympic Games.  8  OLYMPIC REVIEW HIGHLIGHTS The latest news and events from around the Olympic Movement.  20  COVER STORY: THE LONG ROAD TO TOKYO  Six athletes from different sports and countries discuss their journeys to the Olympic Games Tokyo 2020.  60  THROUGH THE LENS  We take a pictorial look at the extraordinary developments of the past 12 months."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(66)\" style=\"top: 331px; left: 51px; height: 118px; width: 270px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(74)\" style=\"top: 686px; left: 48px; height: 135px; width: 132px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(78)\" style=\"top: 767px; left: 215px; height: 100px; width: 135px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(80)\" style=\"top: 539px; left: 378px; height: 108px; width: 135px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(82)\" style=\"top: 757px; left: 380px; height: 105px; width: 136px;\"></div>\n\n      <a class=\"addContentLink\" href=\"https://www.olympics.com/ioc\" target=\"_blank\" style=\"top:509px;left:533px;height:8px;width:108px;\"></a>\n      <a class=\"addContentLink\" href=\"mailto:olympicreview@olympic.org\" target=\"_blank\" style=\"top:517px;left:533px;height:8px;width:111px;\"></a>\n\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(addContentLinks, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "Olympic Review  5  Issue 116  EXECUTIVE BOARD President Thomas Bach Vice-Presidents Anita L. DeFrantz, Zaiqing Yu, John Coates AC, Ser Miang Ng Members Robin E. Mitchell, Nicole Hoevertsz, Denis Oswald, Nenad Lalovic, Kirsty Coventry, Ivo Ferriani, HRH Prince Feisal Al Hussein, Nawal El Moutawakel, Mikaela Cojuangco Jaworski, Gerardo Werthein  OLYMPIC REVIEW Corporate Communications & Public Affairs Director Christian Klaue Editor-in-Chief Katharine Mann French Edition Lucile Tonnerre Spanish Edition Dolores Blázquez Japanese Edition TranslateMedia Production Agency Touchline Production Michael Stoneman, Glyn Wilmshurst, John Murray, Sam Price, Conor Ketley Design Liz Rankin, Ana Burmester, Shyama Rajani, Apostolis Tatasopoulos Image retouching Liz Rankin Translation Denis Echard, Héctor López Conceiro, TranslateMedia Proofreading Elena Ureña, Michel Saint-Raymond, TranslateMedia  66  POSTPONEMENT LESSONS  ISSN: 0377-192X Printed in the UK  Faced with the unprecedented challenge of rescheduling the Olympic Games during a global pandemic, the IOC and its stakeholders have created many positive solutions that will lay a strong foundation for the future.  IMAGES Cover image: Getty Images. Inside: IOC; IOC/Greg Martin; Tokyo 2020; Getty Images; Shutterstock; Alamy.  CONTACTS  OBITUARIES  Olympians and figures from the Olympic Movement who have passed away.  74  MY GAMES  American swimmer and broadcaster Donna de Varona talks about her life-changing Olympic experiences.  78  OLYMPIC STUDIES  Book reviews from the IOC Olympic Studies Centre.  82  FAST FACTS  Facts and figures about how Tokyo 2020 will be delivered in a sustainable way.  Olympic Review uses PEFC-certified paper stock sourced from sustainably managed forests. Olympic Review is published by the International Olympic Committee. The articles published in Olympic Review do not necessarily reflect the opinions of the International Olympic Committee. No articles may be reproduced without the permission of the IOC Corporate Communications & Public Affairs Department.  We have decided to adjust the periodicity of publication of the Olympic Review. The next edition will be a preview of the Olympic Winter Games Beijing 2022 and will be published in December 2021. We look forward to sharing this edition with you. The Olympic Review Team  All information correct at the time of going to press  80  Please send your letters to: Olympic Review, IOC Corporate Communications & Public Affairs Department, Maison Olympique, 1007 Lausanne, Switzerland website: www.olympics.com/ioc email: olympicreview@olympic.org tel +41 (0)21 621 6111"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Behind you  for what’s ahead"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 7-title\" style=\"top:351px;left:43px\" src=\"/116/static/_content/7-title-1.png\">\n\n        <img class=\"halfScale 7-img\" style=\"top:95px;left:44px\" src=\"/116/static/_content/7-img-1.png\">\n        <img class=\"halfScale 7-img\" style=\"top:493px;left:44px\" src=\"/116/static/_content/7-img-2.png\">\n        <div id=\"7-sig\" class=\"abs noOverflow\" style=\"top:799px;left:485px;height:33px;width:123px\">\n          <img class=\"halfScale\" src=\"/116/static/_content/7-sig.png\">\n        </div>\n        <img id=\"7-ctr\" style=\"top:390px;left:328px;cursor:pointer;\" onclick=\"pg7show();\" src=\"/116/static/_content/clicktoread.png\">\n          \n        <div id=\"pg7read\" class=\"d-hidden\" style=\"z-index:1;\">\n          <img id=\"pg7close\" onclick=\"pg7readclose();\" src=\"/116/static/_content/x-button.png\">\n          <p>\n          As we get ready to celebrate the postponed Olympic Games Tokyo 2020, I would first of all like to thank our gracious hosts, the Japanese people, for doing everything possible to organise a safe and secure event. It is thanks to their incredible ability and determination to overcome adversity that the world is able to come together in a celebration of unity and solidarity. For this truly historic accomplishment, they deserve our deepest gratitude, respect and admiration.\n          </p>\n          <p>\n          Overcoming this unprecedented challenge of organising postponed Olympic Games is also a testament to the joint eff orts of the entire Olympic Movement \u2013 the International Olympic Committee (IOC), International Federations (IFs), National Olympic Committees (NOCs), our commercial partners and, of course, the athletes. If this past year has taught us anything it is how strong we are when we stand together.\n          </p>\n          <p>\n          In the year since the Olympic Games were postponed for the first time ever, no one in the Olympic Movement has rested on their laurels. As soon as the decision was announced, all stakeholders devoted themselves completely and steadfastly to reorganising the event one year hence. New dates were chosen, and eff orts made to secure all the sporting venues and the Olympic Village. Our partners stood by us and expressed their ongoing support. Meanwhile, the athletes rearranged their training schedules, found innovative ways to continue their preparations amid restrictions, and some, with medical training, joined in eff orts to fi ght the pandemic alongside front-line medical workers.\n          </p>\n          <p>\n          While eff orts were resolutely focused on the Olympic Games Tokyo 2020, all other activities of the IOC and Olympic Movement stakeholders continued apace too. Athlete programmes, aimed at supporting athletes on and off the field of play, were even stepped up. Meanwhile, Olympic Solidarity funding was increased in order to help NOCs to continue to support their athletes, including refugee athletes. The IFs, too, were able to count on additional support from the IOC. And in a sign of the times, the IOC\u2019s digital strategy really began to bear fruit resulting in growing engagement with audiences \u2013 despite the absence of the Olympic Games.\n          </p>\n          <p>\n          Finally, a key achievement of 2020 was the conclusion of Olympic Agenda 2020, the IOC\u2019s strategic roadmap adopted in 2014. In December, the IOC Executive Board concluded that 88 per cent of the 40 recommendations of Olympic Agenda 2020 had been achieved. In March this year, the 137th IOC Session, once again taking place remotely, unanimously approved the Closing Report. At the same Session, IOC Members adopted Olympic Agenda 2020+5, a set of 15 recommendations making up the roadmap to 2025, establishing solid foundations for the future.\n          </p>\n          <p>\n          None of this could have been achieved without the solidarity demonstrated by the entire Olympic Movement. Now, as we stand poised to celebrate the Olympic Games Tokyo 2020, which promise to be like no previous edition, they serve as a powerful symbol of what we can achieve when we stand united. Faster, Higher, Stronger \u2013 Together. \u25A0           </p>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg7Anim = new TimelineMax();\n          pg7Anim.staggerFromTo(cOf(\"7-title\"), 0.8, {opacity:0, x:-80}, {opacity:1, x:0, ease: Power4.easeOut}, 0.4, 1)\n          .staggerFromTo(cOf(\"7-img\"), 0.8, {opacity:0, y:60}, {opacity:1, y:0, ease: Power4.easeOut}, 0.4, \"-=0.2\")\n          .fromTo(idOf(\"7-sig\"), 0.6, {width:\"0px\"}, {width:\"123px\", ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(idOf(\"7-ctr\"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n        }\n\n        function pg7show() {\n          var k =  document.getElementById(\"pg7read\")\n          k.className = \"readOverlay visible\"\n        }\n  \n        function pg7readclose() {\n          var k =  document.getElementById(\"pg7read\")\n          k.className = \"d-hidden\"\n        }\n  \n        function onPageLeave() {\n          pg7readclose();\n          pg7Anim.stop();\n        }\n        ",
    "searchText": "Olympic Review  7  Issue 116  1  FOREWORD BY THOMAS BACH  1 Thomas Bach was re-elected as IOC President at the IOC Session in March 2021.  A  s we get ready to celebrate the postponed Olympic Games Tokyo 2020, I would ﬁrst of all like to thank our gracious hosts, the Japanese people, for doing everything possible to organise a safe and secure event. It is thanks to their incredible ability and determination to overcome adversity that the world is able to come together in a  celebration of unity and solidarity. For this truly historic accomplishment, they deserve our deepest gratitude, respect and admiration. Overcoming this unprecedented challenge of organising postponed Olympic Games is also a testament to the joint efforts of the entire Olympic Movement – the International Olympic Committee (IOC), International Federations (IFs), National Olympic Committees (NOCs), our commercial partners and, of course, the athletes. If this past year has taught us anything it is how strong we are when we stand together. In the year since the Olympic Games were postponed for the ﬁrst time ever, no one in the Olympic Movement has rested on their laurels. As soon as the decision was announced, all stakeholders devoted themselves completely and steadfastly to reorganising the event one year hence. New dates were chosen, and efforts made to secure all the sporting venues and the Olympic Village. Our partners stood by us and expressed their ongoing support. Meanwhile, the athletes rearranged  their training schedules, found innovative ways to continue their preparations amid restrictions, and some, with medical training, joined in efforts to ﬁght the pandemic alongside front-line medical workers. While efforts were resolutely focused on the Olympic Games Tokyo 2020, all other activities of the IOC and Olympic Movement stakeholders continued apace too. Athlete programmes, aimed at supporting athletes on and off the ﬁeld of play, were even stepped up. Meanwhile, Olympic Solidarity funding was increased in order to help NOCs to continue to support their athletes, including refugee athletes. The IFs, too, were able to count on additional support from the IOC. And in a sign of the times, the IOC’s digital strategy really began to bear fruit resulting in growing engagement with audiences – despite the absence of the Olympic Games. Finally, a key achievement of 2020 was the conclusion of Olympic Agenda 2020, the IOC’s strategic roadmap adopted in 2014. In December, the IOC Executive Board concluded that 88 per cent of the 40 recommendations of Olympic Agenda 2020 had been achieved. In March this year, the 137th IOC Session, once again taking place remotely, unanimously approved the Closing Report. At the same Session, IOC Members adopted Olympic Agenda 2020+5, a set of 15 recommendations making up the roadmap to 2025, establishing solid foundations for the future. None of this could have been achieved without the solidarity demonstrated by the entire Olympic Movement. Now, as we stand poised to celebrate the Olympic Games Tokyo 2020, which promise to be like no previous edition, they serve as a powerful symbol of what we can achieve when we stand united. Faster, Higher, Stronger – Together. ■  Thomas Bach, IOC President"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 8-title\" style=\"top:93px;left:73px\" src=\"/116/static/_content/8-title-1.png\">\n        <img class=\"halfScale 8-title\" style=\"top:189px;left:431px\" src=\"/116/static/_content/8-title-2.png\">\n        <img class=\"halfScale 8-title\" style=\"top:755px;left:142px\" src=\"/116/static/_content/8-quote-1.png\">\n\n        <a href=\"https://iocnewsroom.com/video/thomas-bach-re-elected-international-olympic-committee-president-for-second-term/\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:35px; height:35px;left:514px;top:787px; overflow:visible; \" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#fff\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#fff\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax();\n          pg8Anim.staggerFromTo(cOf(\"8-title\"), 0.8, {opacity:0, x:30}, {opacity:1, x:0, ease: Power4.easeOut}, 0.2, 1)\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop();\n        }\n      ",
    "searchText": "8  Olympic Review Highlights  Olympic  HIGHLIGHTS  The latest news and events from around the Olympic Movement  “With Olympic Agenda 2020 we turned the challenges into opportunities. With Olympic Agenda 2020, we have changed the Olympic Movement” IOC PRESIDENT THOMAS BACH"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top: 539px;left: 591px;height: 16px;width: 78px;\">\n          <a href=\"https://stillmedab.olympic.org/media/Document%20Library/OlympicOrg/IOC/What-We-Do/Olympic-agenda/Olympic-Agenda-2020-5-15-recommendations.pdf\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top: 553px;left: 481px;height: 16px;width: 39px;\">\n          <a href=\"https://stillmedab.olympic.org/media/Document%20Library/OlympicOrg/IOC/What-We-Do/Olympic-agenda/Olympic-Agenda-2020-5-15-recommendations.pdf\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Olympic Review  9  Issue 116  i  nternational Olympic Committee (IOC) President Thomas Bach was re-elected for an additional four-year term during the 137th IOC Session, which was held virtually in March. The 67-year-old, who won gold with the German foil fencing team at the Olympic Games Montreal 1976, received 93 “yes” votes and one “no” from the 94 valid votes.  The 137th IOC Session saw President Bach express his gratitude at being re-elected for a second term and the approval of Olympic Agenda 2020+5.  “Thank you very much from the bottom of my heart for this overwhelming vote of conﬁdence and trust. For me, this is even more overwhelming considering the many reforms and the many difficult decisions we had to take, which affected all of us,” said President Bach after the election. “You know that this touches me deeply. It also makes me humble. When you elected me for the ﬁrst time as your President in 2013 in Buenos Aires, I said that I wanted to lead the IOC according to my campaign motto ‘Unity in diversity’ and be a President for all of you and for all our stakeholders. This commitment is also true for my second and last term. My door, my ears and my heart remain open for each and every one of you. I hope that I can count on your continued dedication, support and friendship also during these four more years.” The Session also unanimously approved Olympic Agenda 2020+5 as the new strategic  roadmap of the IOC and the Olympic Movement through to 2025. Consisting of 15 recommendations, the new roadmap builds on the achievements of Olympic Agenda 2020 and will guide the work of the IOC and the Olympic Movement for the next ﬁve years. The recommendations were developed though an inclusive and collaborative process and are based on key trends that have been identiﬁed as likely to be decisive in the post-coronavirus world. These are: solidarity, digitalisation, sustainability, credibility, and economic and ﬁnancial resilience. Ahead of the adoption of Olympic Agenda 2020+5, the IOC Session also praised the achievements of Olympic Agenda 2020, while its Closing Report was unanimously approved by the IOC Members. “Over the course of the past years, all Olympic Movement stakeholders have contributed to make Olympic Agenda 2020 come to life,” said President Bach. “With Olympic Agenda 2020 we turned the challenges into opportunities. With Olympic Agenda 2020, we have changed the Olympic Movement.” On 21 April, the IOC Athletes’ Commission (AC) received the full support of the IOC Executive Board (EB) for a set of"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 10-quote\" style=\"top:122px;left:99px\" src=\"/116/static/_content/10-quote-1.png\">\n        <h1 id=\"10-no\" class=\"abs 10-no ohr\" style=\"left: 70px; top: 764px; font-size: 4.5em; color: #FFF; padding: 0px; margin: 0px; opacity: 1;\" data-number='{\"to\": 3547, \"comma\": true }'></h1>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg10Anim = new TimelineMax();\n          pg10Anim.staggerFromTo(cOf(\"10-quote\"), 0.8, {opacity:0, x:30}, {opacity:1, x:0, ease: Power4.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"10-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"10-no\")[0]);}}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg10Anim.stop();\n          resetNumbers(\"10-no\");\n        }\n        ",
    "searchText": "10  Olympic Review Highlights  “This consultation was a very important process for us and is part of the ongoing dialogue with the athlete community. We are delighted that the IOC EB fully supported our proposals” KIRSTY COVENTRY  recommendations related to athlete expression at the Olympic Games, particularly in regard to Rule 50 of the Olympic Charter, which provides a framework to protect the neutrality of sport and the Olympic Games. The recommendations are the result of an extensive qualitative and quantitative consultation process implemented by the IOC AC, which started in June 2020 and involved over 3,500 athletes, representing 185 National Olympic Committees (NOCs) and all 41 Olympic sports, and ensuring fully gender-equal representation. The consultation was supported by the Continental Associations’ Athletes’ Commissions and the World Olympians Association. The recommendations include increasing the opportunities for athletes' expression during the Olympic Games, while preserving the podium, ﬁeld of play and official ceremonies from any kind of protests or demonstrations. IOC AC chair Kirsty Coventry (pictured) said: “The goal of this wide outreach was to engage with athletes and hear their thoughts on existing and new opportunities to express their views at the Olympic Games as well as outside Games time. We want to amplify the voices of athletes, and ﬁnd more ways to support the values of the Olympic Games and what sport stands for. This consultation was a very important process for us and is part of the ongoing dialogue with the athlete community. We are delighted that the IOC EB fully supported our proposals.” During its virtual meeting, the IOC EB also discussed a proposal made by President Bach to add the word “Together” after a dash to the Olympic motto “Faster, Higher, Stronger”. The idea – originally proposed by President Bach to the 137th IOC Session – was endorsed by the EB, and the IOC Members have now been asked for their comments. Depending on the outcome  3,547  ATHLETES FROM 185 NOCS AND 41 SPORTS COMPLETED THE RULE 50 SURVEY  of this consultation, a proposal for a change of the Olympic Charter may be put forward to the IOC Session in Tokyo. On 22 April, the IOC announced a landmark move into virtual sports by launching the ﬁrst-ever Olympic Virtual Series (OVS). The IOC will partner with ﬁve International Federations (World Baseball Softball Confederation, Union Cycliste Internationale, World Rowing, World Sailing and Fédération Internationale de l’Automobile) and game publishers to produce the OVS, the ﬁrst-ever Olympic-licensed event for physical and nonphysical virtual sports. Taking place ahead of the Olympic Games Tokyo 2020, the OVS began on 13 May, continuing through to 23 June 2021. The OVS will mobilise virtual sport, esports and gaming enthusiasts all around the world in order to reach new Olympic audiences, while also encouraging the development of physical and non-physical forms of sports in line with the recommendations of Olympic Agenda 2020+5. Earlier in April, the IOC marked the International Day of Sport for Development and Peace (IDSDP) by underlining the paramount role that sport plays in supporting global recovery efforts from the COVID-19 pandemic. “Sport is ready to contribute to building a more human-centred and inclusive society,” said President Bach. “This crisis has made it clearer than ever that sport is the low-cost, high-impact tool par excellence for all countries in their recovery efforts.”"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 12-quote\" style=\"top:572px;left:335px\" src=\"/116/static/_content/12-quote-1.png\">\n        <div class=\"addContentLink\" style=\"top: 389px;left: 151px;height: 16px;width: 141px;\">\n          <a href=\"https://olympics.com/en/news/milano-cortina-2026-winter-olympic-games-emblem-revealed \" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax();\n          pg12Anim.staggerFromTo(cOf(\"12-quote\"), 0.8, {opacity:0, x:30}, {opacity:1, x:0, ease: Power4.easeOut, onComplete: addContentLinks}, 0.2, 1)\n        }\n\n        function onPageLeave() {\n          pg12Anim.stop();\n          removeContentLinks();\n        }\n        ",
    "searchText": "12  Olympic Review Highlights  OLYMPIC GAMES The second IOC Coordination Commission meeting with Milano Cortina 2026 was held virtually on 19 April. Despite the ongoing difficulties related to the COVID-19 pandemic, the Milano Cortina 2026 Organising Committee was able to demonstrate the signiﬁcant progress that it has been able to make since the previous Coordination Commission meeting in September last year. Speaking after the meeting, Commission Chair Sari Essayah commented: “Since our last meeting in September 2020, the Milano Cortina 2026 Organising Committee has made great progress despite the ongoing pandemic. The most visible highlight was the selection process for the new Milano Cortina 2026 emblem, which saw over 871,000 votes cast. Futura, the winning emblem, will become one of the most recognisable symbols in Italy over the next ﬁve years. I am conﬁdent that it will also be one of the most loved.” In March, the Paris 2024 Board of Directors approved the Games’ climate strategy, which commits Paris 2024 to organising the world’s ﬁrst Olympic Games and Paralympic Games with a positive contribution to the climate. The decision follows the IOC’s commitment to make all Olympic Games climate positive from 2030 onwards and to make the IOC as an organisation climate positive from 2024. As part of the strategy, Paris 2024 will reduce its CO2 emissions, in line with the Paris Agreement on Climate Change, offset more than its residual emissions and use its inﬂuence to develop long-term carbon compensation projects. The strategy is based on three pillars: reduction of greenhouse gas emissions, support for projects with a positive climate contribution, and mobilisation of stakeholders to maximise long-term positive impact.  Paris 2024ʼs venue concept is in line with its commitment to host the ﬁrst climate positive Games.  “Since our last meeting, the Milano Cortina 2026 Organising Committee has made great progress despite the ongoing pandemic. Futura will become one of the most recognisable symbols in Italy over the next ﬁve years. I am conﬁdent that it will also be one of the most loved” SARI ESSAYAH"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top: 315px;left: 502px;height: 36px;width: 131px;\">\n          <a href=\"https://olympics.com/ioc/news/airbnb-launches-accommodation-grants-to-support-athlete-travel-costs\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Olympic Review  13  Issue 116  NATIONAL OLYMPIC COMMITTEES The United States Olympic & Paralympic Committee (USOPC) has launched the Team USA Athlete Marketing Platform (AMP) pilot programme, building on the USOPC’s commitment to advance empowerment and earning potential for Team USA athletes. The opt-in, mobile-friendly programme is the ﬁrst of its kind and connects athletes directly with Team USA sponsors and licensees. AMP provides athletes with opportunities for revenue generation and marketing exposure, and will elevate their voice, sport and personal brand in an unprecedented six-month window between the Olympic Games Tokyo 2020 and the Olympic Winter Games Beijing 2022. The Kenyan NOC is set to build an OlympAfrica Centre in Ruai after signing a Memorandum of Understanding (MoU) with the Nairobi County Government. The NOC President, IOC Member Paul Tergat, and Deputy Governor for Nairobi Ann Kananu signed the MoU, under which the government has given land free of charge to the NOC. The NOC is set to take on the operational costs, with OlympAfrica providing seed funding for the centre.  Athletes to receive Airbnb travel credit In April, Worldwide Olympic Partner Airbnb, in partnership with the IOC, announced the launch of a new initiative that will provide elite athletes, Olympians and Paralympians with Airbnb accommodation credits. Over the next eight years, the Athlete Travel Grants programme will offer up to 500 athletes per year a USD 2,000 Airbnb credit to use for travel-related accommodation costs linked to their sporting careers. Above Airbnb co-founder Joe Gebbia with President Bach.  “Play True Day” celebrated around the globe  Team USA athletes like luger Chris Mazdzer will be able to beneﬁt from the USOPCʼs new initiative.  The World Anti-Doping Agency's (WADA) 2021 “Play True Day” campaign reached over 87 million people around the globe on 9 April. Centred around the theme “What does Play True mean to you?”, the campaign once again saw the IOC, athletes, national and regional anti-doping organisations, International Federations, governments, major event organisers and other stakeholders from the global antidoping community unite in celebration of the Play True message."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "14  Olympic Review Highlights  Estonian biathlete Regina Oja features as one of 10 team captains in the Biathlon Climate Challenge.  planted in a reforestation project. The launch of the Challenge is part of the IBU’s Sustainability Strategy 2020-2030, which commits the IBU to addressing sustainability needs in ﬁve different areas: climate, sport, people, venue and events, and communications and awareness. Its climate goal is to reduce emissions aligned with the goals of the Paris Climate Agreement, and to be climate neutral as a sport by no later than 2030.  INTERNATiONAL FEDERATiONS  Atos hosts virtual expedition across Japan Worldwide Olympic Partner Atos celebrated the IDSDP on 6 April with the launch of a new virtual challenge to inspire its employees to remain #StrongerTogether during the COVID#19 pandemic. The Great Atos Global Expedition will also help build excitement ahead of the Olympic Games Tokyo 2020, as it challenges participants to virtually travel 2,021km across host country Japan.  On 22 April, World Athletics and the organisers of the World Athletics Indoor Championships Belgrade 2022 marked Earth Day 2021 by signing up to the United Nations Framework Convention on Climate Change's (UNFCCC) Sports for Climate Action Framework. Signing up to the Framework underscores World Athletics’ commitment to its Sustainability Strategy – a 10-year road map unveiled in April 2020 that includes a goal of transitioning to carbon neutrality across all its operations and events by 2030. Also to mark Earth Day 2021, the International Biathlon Union (IBU) announced the ﬁrst Biathlon Climate Challenge, which seeks to connect an active lifestyle with climate action. Fans are challenged to join one of 10 different teams – all led by biathlon stars – and track their physical activity via a ﬁtness app, which will convert the distance they have covered or the calories they have burned into trees  The International Basketball Federation (FIBA) has announced the official launch of the FIBA Players' Mentorship Program. Guided by its Players' Commission, FIBA wants to provide support for players not only on the court but also off it. The primary objective is to train at least one Players' Mentor per National Federation to help support all elite youth players in that country. FIBA wants all players to be able to compete at their highest level, enhance their health and well-being and receive meaningful educational opportunities. The International Tennis Federation (ITF) has announced the results of a ﬁrst-of-itskind global research project examining sports gender equality across the media and social media, commissioned as part of the ITF’s Advantage All gender equality strategy. The publication of this research was discussed during the ITF’s global forum “Level the Playing Field”. Top athletes joined senior business leaders to share their experiences, motivations and expertise for how to increase the number of women in leadership positions, grow the audience and engagement in women’s sport, and inﬂuence the narrative around women’s sport and female athletes."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Leaving a legacy that matters.  As lead integrator, Atos migrated all critical IT systems to the cloud, orchestrating it all for future Olympic and Paralympic Games. #AtosMakeItHappen"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 16-quote\" style=\"top:422px;left:464px\" src=\"/116/static/_content/16-quote-1.png\">\n        <h1 id=\"16-no\" class=\"abs 16-no ohr\" style=\"left: 537px; top: 118px; font-size: 4.5em; color: #FFF; padding: 0px; margin: 0px; opacity: 1;\" data-number='{\"to\": 1900, \"comma\": true }'></h1>\n\n      <a class=\"addContentLink\" href=\"https://olympics.com/ioc\" target=\"_blank\" style=\"top: 288px; left: 326px; height: 14px; width: 88px;\"></a>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax();\n          pg16Anim.staggerFromTo(cOf(\"16-quote\"), 0.8, {opacity:0, x:30}, {opacity:1, x:0, ease: Power4.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"16-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:addContentLinks,function(){animateNumber(cOf(\"16-no\")[0]);}}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg16Anim.stop();\n          resetNumbers(\"16-no\");\n          removeContentLinks()\n        }\n        ",
    "searchText": "16  Olympic Review Highlights  YOUTH OLYMPiC GAMES The Organising Committee for the Winter Youth Olympic Games (YOG) Gangwon 2024 has ensured that young people will play a key role in planning and promoting the Games by launching a new youth engagement programme. Thirty young people have been selected to participate in the “Youth Supporters” initiative, which will see them work closely with the Organising Committee (GYOGOC) over the next year on the development of digital content, communications and other YOG-related activities to help engage young people throughout the host country and beyond.  The initiative ties in with GYOGOC’s vision, which was unveiled during the ﬁrst IOC Coordination Commission meeting at the end of March. The vision – “Youth celebrating peaceful coexistence and unity through sport to create a better future together” – will provide the foundation for all GYOGOC activities as it prepares for the 4th Winter YOG.  1,900 ATHLETES WILL ATTEND GANGWON 2024  To see all of the Olympic Movement news go to olympics.com/ioc  “More young elite athletes will be able to benefit from the experience at the Winter Youth Olympic Games Gangwon 2024 while we keep the Games sustainable” IOC PRESIDENT THOMAS BACH  Gangwon will host the worldʼs ﬁnest youth athletes in 2024."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 18-title\" style=\"top:132px;left:44px\" src=\"/116/static/_content/18-title-1.png\">\n        <img class=\"halfScale 18-title\" style=\"top:259px;left:44px\" src=\"/116/static/_content/18-sub.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg18Anim = new TimelineMax();\n          pg18Anim.staggerFromTo(cOf(\"18-title\"), 0.8, {opacity:0, x:30}, {opacity:1, x:0, ease: Power4.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg18Anim.stop();\n        }\n        ",
    "searchText": "18  Beyond the Rings  BEYOND THE RINGS  THESE GAMES WiLL MAKE US PROUD Tokyo 2020 Sports Director Kotani Mikako looks ahead to what she believes will be a special Olympic Games this summer, and discusses her work promoting gender equality within her Organising Committee and among wider Japanese society  A  s an Olympian myself, a lot comes to mind when I think about what the athletes eyeing the Olympic Games Tokyo 2020 are going through – or have had to go through. Physically, many of them will likely have peaked last summer but now they have to build it back up again due to the Games' ﬁrst-ever postponement. It will have affected their motivation, their conditioning. Because of age or other factors, some athletes have had to abandon their Olympic dreams. While some have had their careers derailed by the postponement, others have taken it as a blessing in disguise. In more normal times, an athlete can be so preoccupied with competing that they will ﬁnd it difficult to pause and reﬂect. The extra year has allowed some athletes to ask why they do what they do. It also allowed them to work on their basic ﬁtness. So some positives have come out of a one-year layoff. Some athletes will ﬁnd it stressful when they come over for the Games, able to only shuttle from the Olympic Village to the competition venue and back. But the terms are the same for everyone. You are still trying to determine who is the best in the world. You only need to look back to the winner-takes-all play-off in judo between  Abe Hifumi and Maruyama Joshiro for Japan’s men’s 66kg spot. There was no crowd, no extravagance. Just two hard-competing athletes who left everything out there. And that is what I would like the athletes to keep in mind. A gold medal from this summer will be no different to the gold medals of past Games. These Games will be a special experience for any athlete who has what it takes to participate. Alongside my role as Sports Director of the Tokyo Organising Committee of the Olympic and Paralympic Games (Tokyo 2020), I was asked by Tokyo 2020 President Hashimoto Seiko to lead the Organising Committee’s gender equality team. President Hashimoto kept it simple by asking me for two things: to work fast and to communicate what we do. My ﬁrst action on gender equality was internal. If we are the ones sending the message then I felt it was crucial for me to understand where we, as a committee, stood on the issue. I conducted a poll and the replies were varied. It made me aware of what our people are thinking on gender equality, diversity and inclusion, and through the process, I think it’s reminded them that what they do at Tokyo 2020 matters. A few of the replies said they could feel proud again. After the Games, Tokyo 2020 will disband and the workers will go back to wherever they were seconded from, or move on to new places. When they do, I believe they will have a new understanding and outlook on gender equality and the word will spread from there. Since I’ve been leading the gender equality team, a lot of people – who are not in the line of work we are in – have been coming up to me to offer a lot of positive words about what we are trying to achieve. I sense the expectations from the public are high and I’m more than happy that I’m being  equated with gender equality. I am like anyone else – I’m an athlete, a wife, a mother who just happens to be the Tokyo 2020 Sports Director and is working to promote gender equality. If I can do it and help make a difference, it might encourage others to do the same. If I could be granted a wish – and I know it’s a wish – I would love nothing more than to see a medal awarded to every single Games participant. Because it is not only the athletes who make the Games happen. From the competition officials at the International Federations, to the volunteers, to my colleagues at Tokyo 2020, there are so many people working behind the scenes going above and beyond the call of duty for the Games. They might not receive a medal, but I want them to be proud for the rest of their lives of having taken part in the historic Olympic Games Tokyo 2020. ■  Kotani Mikako is a former artistic swimmer who won two bronze medals at the Olympic Games Seoul 1988. She now works as Tokyo 2020’s Sports Director and also heads up the Organising Committee’s gender equality team."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n      <a class=\"addContentLink\" href=\"http://alizila.com/\" target=\"_blank\" style=\"top:871px;left:363px;height:14px;width:64px;\"></a>\n      ",
    "script": "\n        function onPageEnter() {\n          addContentLinks()\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 20-title\" style=\"top:196px;left:78px\" src=\"/116/static/_content/20-title-1.png\">\n        <img class=\"halfScale 20-title\" style=\"top:342px;left:85px\" src=\"/116/static/_content/20-title-2.png\">\n        <img class=\"halfScale 20-title\" style=\"top:487px;left:78px\" src=\"/116/static/_content/20-title-3.png\">\n\n        <a href=\"https://www.youtube.com/watch?v=sHXcWvZr-9c\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:50px;height:50px;left:514px;top:693px;overflow:visible;\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#fff\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#fff\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax();\n          pg20Anim.staggerFromTo(cOf(\"20-title\"), 0.8, {opacity:0, x:30}, {opacity:1, x:0, ease: Power4.easeOut, onComplete: addContentLinks}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg20Anim.stop();\n          removeContentLinks()\n        }\n        ",
    "searchText": "20  Cover story: The Long Road to Tokyo  THE LONG ROAD TO TOKYO SIX ATHLETES FROM DIFFERENT SPORTS AND COUNTRIES REVEAL HOW THEY HAVE COPED WITH THE CHALLENGES THAT WERE THROWN THEIR WAY AS A RESULT OF THE COVID-19 PANDEMIC, AND EXPLAIN HOW THEY MANAGED TO TRAIN AND STAY FOCUSED ON THEIR GOAL AFTER THE POSTPONEMENT OF THE OLYMPIC GAMES TOKYO 2020. BY LIA HERVEY"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  Issue 116  21"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 22-title\" style=\"top:230px;left:46px\" src=\"/116/static/_content/22-title-1.png\">\n        <img class=\"halfScale 22-title\" style=\"top:450px;left:45px\" src=\"/116/static/_content/22-sub-1.png\">\n        <img class=\"halfScalCe 22-img\" style=\"top:329px;left:112px\" src=\"/116/static/_content/22-img-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax();\n          pg22Anim.staggerFromTo(cOf(\"22-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"22-img\"), 0.6, {scale:0}, {scale:0.5, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg22Anim.stop();\n        }\n        ",
    "searchText": "22  Cover story: The Long Road to Tokyo  “  “The allure of an Olympic gold medal is still there” ADELINE GRAY USA, WRESTLiNG  A  deline Gray grew up just an hour from the USAís elite Olympic Training Centre in Colorado Springs, Denver, and by the age of 16 sheíd fallen in love with wrestling and was training with Team USAís senior women. By 17, she had won her ˇrst junior world title. She went on to become a two-time Pan American champion and the only American athlete to win ˇve senior world titles. At Rio 2016, the 30-year-old went into the 75kg event with high expectations, but lost her quarter-ˇnal bout by a single point. With Tokyo 2020 on the horizon, sheís ready to compete at her second Olympic Games with one goal ñ to become the ˇrst-ever US woman to win a heavyweight wrestling title. When the USA went into lockdown, Gray had to leave the Olympic Training Centre where sheíd been training with her sister Geneva and team-mates, and move into a house-share with a friend, sister and husband. Without the mat to train on, Geneva, also a wrestler, became her training partner and, together, they suffered grass stains, carpet burns and abdominal exercises caused by so much laughter.  My husband and I were planning on starting a family at the end of this year. I was hoping to be pregnant now. I was living at the Olympic Training Centre and was supposed to stay there until after the Olympics. At the start of the national lockdown the Training Centre called us and gave us three days’ notice to leave. They said: “We think the Training Centre is shutting down”, and the next day they said: “You’ve got to get out”. We immediately thought: “Where do we go? Where am I going to train? Where am I going to sleep?” It was deﬁnitely scary. We were homeless for a short while. Most people who trained at home realised how many more reps you have to do to get the exact same or subpar results. Normally I have a lot of resources and elite equipment which helps my body train at a maximum effort, without having to do 1,000 reps. It made me realise how much science and effort from other people goes into my training. I realised wrestling is a lot harder to do on a carpet. My sister and I ended up with a lot of carpet burns. The allure of an Olympic gold medal is still there; Olympic champion is forever. The gold medal is long sought after, so that would be a special moment. I'm the best athlete in my weight class and, at the last Olympics, I just happened to have a bad day. I lost by one point. Japan is the best at women's wrestling, so I think"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.youtube.com/watch?v=uncfcHheQTM\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:35px; height:35px;left:44px;top:347px; overflow:visible; \" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#fff\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#fff\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "they're going to do a wonderful job. We have a lot of tough matches ahead of us against Japan and, luckily, the Japanese woman (Minagawa Hiroe) in my weight class will be on the other side of the weight bracket because we competed in the ﬁnals of the 2019 World Championships, so they will actually separate us. We could both end up in the Olympic ﬁnal in Tokyo in her home country. I hope that she makes it to the ﬁnal and that's who I compete against in the ﬁnal. I'm a little nervous of the hometown advantage, but I'm also excited to compete against such a great rival in Japan. If I could show just a glimmer of hope that there's some resilience and strength, and could empower women to make it through this time, I would love to be that beacon.  1 Adeline Gray is a ﬁve-time world champion but is seeking a ﬁrst Olympic medal."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 24-title\" style=\"top:189px;left:46px\" src=\"/116/static/_content/24-title-1.png\">\n        <img class=\"halfScale 24-title\" style=\"top:478px;left:45px\" src=\"/116/static/_content/24-sub-1.png\">\n        <img class=\"halfScalCe 24-img\" style=\"top:350px;left:126px\" src=\"/116/static/_content/24-img-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax();\n          pg24Anim.staggerFromTo(cOf(\"24-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"24-img\"), 0.6, {scale:0}, {scale:0.5, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg24Anim.stop();\n        }\n        ",
    "searchText": "24  Feature: Cover story: Tokyo The 2020 Long Road to Tokyo  1  “My key objective is to inspire a generation”  DOI REMI ANRI JAPAN, HANDBALL  B  orn to a French father and Japanese mother, Doi Remi Anri played handball in primary school. He attended Nippon State University, the top university for handball in Japan, and in 2012 moved to France and played for the second team of ChambÈry Savoie Mont-Blanc in the countryís top division. He was promoted to the top team shortly after and turned professional. Doi played in France for six seasons before returning to Japan to help develop the national team. He now plays for Osaki Osol in the Japan Handball League and is captain of his national team. Tokyo 2020 will be Doiís ˇrst Olympic Games. When the Games were postponed, he turned to social media platform TikTok from his home in Japan to try and raise the proˇle of handball. Through his home-recorded videos, dancing and entertaining people, he gathered more than two million followers."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "2  “  1 Doi Remi Anri in action for Japan at the World Handball Championships in 2019. 2 Doi has kept more than two million followers amused with his TikTok videos over the past year.  I don't know why I love handball, but I just do. From the moment I watched it, I loved it. It’s hard to explain why. For me, the Olympic Games are my only dream. They are everything. I don't have any experience of the Olympics yet – this will be the ﬁrst time for me – and having the Olympics in Japan is very, very special. Handball is not famous in Japan yet, so I want to be the person – and the team – who inspires a lot of people to take up the sport and love it. Ultimately, people’s lives and life itself are more important than anything, but I’m also an athlete – and, as an athlete, I want to play my sport and compete at the Olympics. Throughout the pandemic, I have had faith and belief that the Olympics will happen and I’ve always believed that I should try to do my best and just train throughout. That’s all. I couldn't train with my team-mates during the lockdown, so I had to do all my training at home. I didn’t mind that; I felt like I had the capacity to train for one more year and I actually had some injuries, so the lockdown meant that I managed to heal those injuries and come out  stronger. I tried at all times to maintain positive thinking. I’d been with my team-mates all of the previous year, so I actually enjoyed the time spent apart from them. Sometimes you need time like this. Japan’s men’s handball team is in good condition now and we are in a good place, so I'm really looking forward to competing. My ultimate goal is winning a gold medal but, above anything, my key objective is to inspire a generation to enjoy handball. The ﬁghting spirit we show is more important than winning to me. I want to highlight and bring visibility to handball in Japan. During the pandemic I made TikTok videos and the main reason was to raise awareness of handball. There has been so much stress during the pandemic and, for me, being stress-free is very important. The fans gave lots of positive comments about my videos and that was very helpful for me in that period. The Olympic Games are my dream, but I want the Olympics to be safe. That’s the most important thing."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 26-title\" style=\"top:126px;left:46px\" src=\"/116/static/_content/26-title-1.png\">\n        <img class=\"halfScale 26-title\" style=\"top:294px;left:44px\" src=\"/116/static/_content/26-sub-1.png\">\n        <img class=\"halfScalCe 26-img\" style=\"top:164px;left:169px\" src=\"/116/static/_content/26-img-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax();\n          pg26Anim.staggerFromTo(cOf(\"26-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"26-img\"), 0.6, {scale:0}, {scale:0.5, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg26Anim.stop();\n        }\n        ",
    "searchText": "26  Feature: Cover story: Tokyo The 2020 Long Road to Tokyo  “We all still have a goal and a dream” WAYDE VAN NIEKERK SOUTH AFRiCA, ATHLETiCS  1 Wayde van Niekerk on his way to a second world 400m title in 2017.  1  W  ayde van Niekerk was born in Cape Town, South Africa, into a sporting family. His mother, Odessa Swarts, was a sprinter and his cousin, Cheslin Kolbe, won bronze with South Africa when rugby sevens made its Olympic debut at Rio 2016. He got his ˇrst breakthrough at the 2010 World Junior Championships, placing fourth in the 200m with a time of 21.02. He soon started to show skill in the 400m too and, by 2015, was the 400m world champion. In Rio, he added Olympic gold to his medal collection and, a year later, won another 400m world title as well as a silver in the 200m. Van Niekerk is the current world and Olympic record-holder in the 400m and, in 2017, became the only sprinter in history to have run sub-10, sub-20, sub-31 and sub-44-second times at 100m, 200m, 300m and 400m."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top: 13px;left:699px;height:76px;width:18px;\">\n        <a href=\"http://omegawatches.com/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          addContentLinks()\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "omegawatches.com  SEAMASTER DIVER 300M As the Official Timekeeper of the Olympic Games, OMEGA is celebrating this summer’s historic event with a new 42 mm timepiece in stainless steel. Built in the colours of Tokyo 2020, this exclusive Master Chronometer watch features a blue ceramic bezel, a white ceramic dial and the competition’s emblem transferred under the sapphire crystal on the caseback."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.youtube.com/watch?v=xG91krXuxyw\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:35px; height:35px;left:44px;top:150px; overflow:visible; \" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#fff\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#fff\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "28  Cover story: The Long Road to Tokyo  “  When the pandemic struck, my wife and I knew that we had to just try our best to be obedient to what was expected of us and what the leaders of South Africa asked from us, and that's all we could have done. It was deﬁnitely a bit scary. We weren’t sure what was next and, as the Olympic Games were creeping closer, there was an amount of stress not knowing: “Do we train? Do  we race?” We couldn't train the way we wanted to. I think, even now, there are days where we can't really train the way we want to and I’m glad that things are slowly but surely starting to get back [to normal] with competitions returning. Once I had accepted that the Olympics were postponed, I ﬁxed my mind on working and training and getting as strong as possible.  I’m glad I stuck to that as, if I look at my times today, I'm among the top in the world again. It's very early in the season and it's something really positive to use moving forward and drive my body to where I want it to be. Even though we're going through a pandemic, there's always room for improvement and growth. A positive point is that we are all healthy and all still going. We all still have a goal and a dream to work towards – I ﬁnd that a massive positive and something that we should be grateful for. There are people who have lost loved ones, families and friends, and we are still going, still moving and we shouldn't take this for granted. We had a total lockdown in South Africa. We had to stay in our house for months and months, and obviously we missed family and friends.  But I also just got to enjoy quality time with my wife and working and training towards a time when, in life, slowly but surely we are creeping back to normal. I'm fully invested in, and working towards, the Olympic Games, making sure that my body stays healthy and ready. We are working towards where we always want to be – [the Olympic Games are] one of the biggest highlights of our athletic careers. It’s one of those opportunities where you can showcase your talents and represent your country and compete against the best in the world. It challenges your body to the absolute limits that you haven't reached and I want to use this as another opportunity to just push myself beyond any limits and ranges that have been sitting in front of me.  1 Van Niekerk has struggled with injuries over the past few years and has only recently started competing in international events again. 2 Working on his sprint start.  1  2"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:266px;left:58px;height:17px;width:220px;\">\n        <a href=\"http://gettyimages.com/editorial-images/sport\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:290px;left:33px;height:12px;width:13px;\">\n        <a href=\"https://www.instagram.com/gettyimages/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:290px;left:49px;height:12px;width:14px;\">\n        <a href=\"https://twitter.com/gettyimages/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:820px;left:32px;height:12px;width:150px;\">\n        <a href=\"mailto:eugene.cariaga@gettyimages.com\" target=\"_blank\"></a>\n      </div>\n    ",
    "script": "\n        function onPageEnter() {\n          addContentLinks() \n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "BACK ON TRACK For the latest sports coverage of all major compe ons, including every medal of the upcoming Tokyo 2020 Olympic Games, visit ge yimages.com/editorial-images/sport @ge ysport  For coverage and licensing queries please contact Eugene Cariaga: eugene.cariaga@ge yimages.com 82385468, Clive Rose  Ofﬁ cial photographic agency of the IOC"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 30-title\" style=\"top:147px;left:47px\" src=\"/116/static/_content/30-title-1.png\">\n        <img class=\"halfScale 30-title\" style=\"top:388px;left:45px\" src=\"/116/static/_content/30-sub-1.png\">\n        <img class=\"halfScalCe 30-img\" style=\"top:267px;left:126px\" src=\"/116/static/_content/30-img-1.png\">\n\n        <div class=\"addContentLink\" style=\"top:143px;left:42px;height:137px;width:260px;\">\n          <a href=\"https://iocnewsroom.com/video/dutch-based-iranian-taekwondo-athlete-dina-langeroudi-selected-for-the-ioc-refugee-olympic-team-to-compete-in-tokyo-2020/\" target=\"_blank\"></a>\n        </div>\n        \n      ",
    "script": "\n        function onPageEnter() {\n          pg30Anim = new TimelineMax();\n          pg30Anim.staggerFromTo(cOf(\"30-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"30-img\"), 0.6, {scale:0}, {scale:0.5, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg30Anim.stop();\n          removeContentLinks()\n        }\n        ",
    "searchText": "30  Feature: Cover story: Tokyo The 2020 Long Road to Tokyo  1  “I’ve risked everything for my dream”  DINA POURYOUNES  IOC REFUGEE OLYMPiC TEAM, TAEKWONDO  1  D  ina Pouryounesí parents were both grandmasters of taekwondo and her ˇrst coaches. At the age of seven, she won the Iranian Taekwondo Childrenís National Championships and for eight years she competed for the Iranian national team. But at the end of 2014, aged 22, Pouryounes took a long and dangerous journey to the Netherlands with trainer Ramin Padidar, and sought asylum at the Ter Apel refugee camp. In the last seven years, she has lived in ˇve cities across the Netherlands and six different asylum centres while practising taekwondo in difficult circumstances to keep her dream alive. She found Dutch-Iranian master, Manni Zareei, who started to coach her, and would travel an hour on the bus to train with him in The Hague. But despite the difficulties, the 29-year-old has competed on the world stage and, with the help of her coaches, has won more than 35 international medals, including European silver. Through the Olympic Solidarity Refugee Athlete Support Programme and a scholarship from World Taekwondo, Pouryounes receives funding and support that enables her to train and take part in international competitions."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  31  Issue 116  “  When the pandemic hit, there were so many thoughts going through my head. Mentally it was so tough as I’ve risked everything for my dream, and not knowing what would happen with my life was tough. I just didn’t know what my future would be without the sport I love and the dream of the Olympics. In the Netherlands, taekwondo isn’t widely practised and we have no big-name athletes to train with. Despite this, I’ve trained for six years with very little money and without partners and still managed to get the results. In one respect, though, when coronavirus came, nothing actually changed for me. I have always been at home alone with no team support and only home gym equipment, so I think that the international lockdowns were  1 Dina Pouryounes dreams of becoming the ﬁrst medallist for the IOC Refugee Olympic Team.  actually a bigger shock to other athletes from the national teams. I’ve trained in difficult and unusual situations that are not set up for an elite athlete. In the last seven years, I’ve lived in six different asylum centres. I’ve trained outside in the rain, in parks, on tiles, on a stone ﬂoor. I adore taekwondo and to qualify for the Olympics makes me overwhelmed with happiness. I am part of the IOC Refugee Olympic Team. That gives me such pride and I am so thrilled to represent the team because I want to do my best for all the refugees. To win a medal would be an incredible feat. It would show the world that refugees aren’t pathetic and are actually very hard-working people. We have to work so much harder than other athletes for reasons others don’t even think about, which seem so normal to them. They are in their homes with the support of their family and the support of their country. They have doctors, psychologists, nutritionists and all sorts of extra support. The challenges are so great for us that simply by qualifying we have achieved something extraordinary. For me, to go to the Olympics shows that my hard work and the path I followed was right. I committed to training every day – two to three times a day – and that is not easy, but I’m proud of that choice. I could easily go and live my life in another way, but I have chosen to follow my dream. I have given my all and I will be 100 per cent Dina."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 32-title\" style=\"top:174px;left:46px\" src=\"/116/static/_content/32-title-1.png\">\n        <img class=\"halfScale 32-title\" style=\"top:433px;left:45px\" src=\"/116/static/_content/32-sub-1.png\">\n        <img class=\"halfScalCe 32-img\" style=\"top:314px;left:102px\" src=\"/116/static/_content/32-img-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg32Anim = new TimelineMax();\n          pg32Anim.staggerFromTo(cOf(\"32-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"32-img\"), 0.6, {scale:0}, {scale:0.5, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg32Anim.stop();\n        }\n        ",
    "searchText": "32  Cover story: The Long Road to Tokyo  2  “I feel an incredible amount of pressure” 2  ADAM ONDRA  1  CZECH REPUBLiC, SPORT CLiMBiNG  W  ith two climbing parents, Adam Ondra was climbing from childhood. His earliest challenges were on the polished limestone rocks of the Moravian Karst, in the Czech Republic. Conquering the tricky ascents was the best teacher and he attributes it to his skill, which has already gained him seven World Cup and ˇve World Championship titles. By the age of nine, Ondra was obsessed, and his family would take extended weekends across Europe tackling new and exciting crags. His dream to be a professional climber was realised at the age of 10, when he secured professional sponsorship. He went on to conquer some of the worldís toughest climbs, including the ˇrst free ascent of Silence in Norway. In 2016, sport climbing was added to the Olympic programme and Ondra decided to take on his greatest challenge yet. Since itís a combined event, to win a medal his expertise in bouldering and lead climbing isn't enough; he has also had to master speed climbing.  “  It’s my dream and now it’s ﬁnally happening. Coming from a small country like Czech Republic, the pressure is on because we don’t have that many medal hopefuls. When the postponement was announced, I thought of it as my advantage, and I never faced motivational problems. I thought it would give me time to train and work harder, and that the delay might actually help me. The Olympic preparation started two years ago for me. Training for something that"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.youtube.com/watch?v=DBFZPJKbb_g\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:35px; height:35px;left:404px;top:487px; overflow:visible; \" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#0e0e0e\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#0e0e0e\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1 Adam Ondra competing at the IFSC Climbing World Cup event in Utah (USA) in May 2021. 2 Ondra has found some innovative ways to train over the past year.  I do not particularly enjoy, speed climbing, is a big challenge. I have been practising the lead and bouldering disciplines since I was a child, but in Tokyo it will be a combined event, which really forces me to stay in the gym. I basically started from scratch with speed climbing, and it's not easy for me to catch up. In climbing you have to confront the fear of falling, which is no problem for me after so many years. I don't suffer vertigo and I trust my ear. I know what can happen if something goes wrong; I just don't think about it. However, there is the fear of failure. You can’t avoid it, and you have to deal with it. I've competed all over the  world and climbed so many routes, but with the Olympics I feel an incredible amount of mental pressure. I don’t think I’ve faced anything even close to this before. In climbing, it's not just physical ability but it's also about reading the route. And sometimes ﬁnding the easiest way is more crucial than being physically strong enough. Combining all the physical and psychological factors into that one moment – and knowing that on the lead route, just one slip of the foot could result in a very bad result – is very difficult. You just have to make a decision and go for it, and rely on your conﬁdence and intuition. Some years ago, I would have said that not even the Olympics could not match the ascent of Silence in Norway, my proudest achievement. But in a way, the postponement makes the value even higher. To me, the value is based on how much effort you put into something, and I already feel that I've dedicated myself so much more than I ever imagined for just one climbing event. Now, I would say that the Olympics could be more important than anything I’ve ever done."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 34-title\" style=\"top:138px;left:46px\" src=\"/116/static/_content/34-title-1.png\">\n        <img class=\"halfScale 34-title\" style=\"top:328px;left:45px\" src=\"/116/static/_content/34-sub-1.png\">\n        <img class=\"halfScalCe 34-img\" style=\"top:203px;left:171px\" src=\"/116/static/_content/34-img-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax();\n          pg34Anim.staggerFromTo(cOf(\"34-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"34-img\"), 0.6, {scale:0}, {scale:0.5, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg34Anim.stop();\n        }\n        ",
    "searchText": "34  Cover story: The Long Road to Tokyo  “I had to change my perspective of leadership” ROWIE WEBSTER  AUSTRALiA, WATER POLO  1 Rowie Webster (left) competing at the World Championships in 2017.  1  I  t was 2000 ñ the year of the Olympic Games in Sydney ñ when Australiaís Rowie Webster ˇrst tried water polo. Her countryís womenís team had beaten the USA to the gold medal with one second to go, and a month later she sat at the dinner table and told her parents she planned to go to the Olympic Games herself. Twelve years on she brought home a bronze medal from the Olympic Games London 2012, and she was about to captain the team at her third Games when the pandemic hit. Webster spent the next seven months separated from her team in Melbourne, in one of the strictest city lockdowns in the world. When they were able to, the team decided to train and live together in a small town near Byron Bay, putting their lives on hold and staying away from family. The decision was also taken not to compete overseas, so theyíve had only the menís under-20 development squad to train with. By the time they line up on the biggest stage at Tokyo 2020, Websterís Australia will have gone almost 17 months without an international competition."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "36  Cover story: The Long Road to Tokyo  “  Water polo is the way that I can express myself best. I feel most free when I’m in the pool. I love training. I love the aggression of it. I love the ﬁtness of it. I can be exactly who I want to be. Being apart was a big test of our resilience. The reason we play team sports is because we love the camaraderie, we love battling each other in training sessions, and it became very 1  isolating. It was hard, but the pull of the Olympic spirit is so strong that just to know there was a chance of representing my country at the Olympic Games kept me going. Every day I would get up, set myself a goal and make sure I had a purpose for that day. I had to completely change my perspective of what leadership is. I made an active decision early on to make sure that everyone was actually OK ﬁrst and foremost, and my role started to include overseeing my team-mates’ mental health. We would collectively do training sessions online and really tried to come together. We used that time to work on ourselves and to study other teams.  2  1 Webster has gone almost 17 months without an international competition. 2 Australia's women's water polo team hold their boarding passes ahead of their ﬂight to Tokyo.  I didn't have access to a pool, so I turned my garage into a gym. I live by the bay, so I was swimming in 9° water with 5° air temperature. Now, Iʼm the ﬁttest and strongest I've ever been. We werenʼt competing so we didnʼt have to go out and peak and then come back down. We werenʼt travelling to tournaments all around the world and dealing with jetlag. Just getting a good solid block of work into my body was a huge thing for me, and then having the energy to work on tactics, study the opposition and see them in a different light. As athletes, we never get the opportunity to miss our sport because itʼs constant training and weʼre constantly  under fatigue. So, getting my sport taken away was almost a blessing because the ﬁre is now fuelled again. Let me at it. Let me do what I love. I absolutely adore this. This is a choice that Iʼm making to be one of the best players in the world. I think the huge hurdle that weʼre going to face is to go almost 17 months without an international match, with the ﬁrst one being at the Olympics. It’s a big jump, but weʼve accepted that. We’ve been watching other countries compete internationally and being isolated in Australia has been a little bit daunting, but hopefully it pays off in the long run. At Rio 2016 we were unsuccessful, so I feel going into Tokyo thereʼs unﬁnished business. To win a gold medal would be phenomenal."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "The official payment technology partner of Tokyo 2020 and proud worldwide sponsor of the Olympic and Paralympic Movement.  Kanoa Igarashi Japan, Surfing  Noah Lyles USA, Athletics  Milica Mandić Serbia, Taekwondo  Teresa Perales Spain, Para swimming"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 38-title\" style=\"top:151px;left:46px\" src=\"/116/static/_content/38-title-1.png\">\n        <img class=\"halfScale 38-title\" style=\"top:223px;left:45px\" src=\"/116/static/_content/38-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg38Anim = new TimelineMax();\n          pg38Anim.staggerFromTo(cOf(\"38-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg38Anim.stop();\n        }\n        ",
    "searchText": "38  Cover story: The Long Road to Tokyo  The team behind the team Around the athletes is a strong entourage of coaches, agents, scientists, family members and partners. When the pandemic struck, it hit many lives in different ways  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 39-quote\" style=\"top:767px;left:45px\" src=\"/116/static/_content/39-quote-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg39Anim = new TimelineMax();\n          pg39Anim.staggerFromTo(cOf(\"39-quote\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg39Anim.stop();\n        }\n        ",
    "searchText": "Olympic Review  39  Issue 116  2  G  eneva Gray was living in Georgia, USA, about two or three hours away from Adeline, when her sister asked her to come to Colorado as her wrestling training partner for just a couple months up until the Games. When the pandemic struck that turned into 15 months. “I would say most of the time I try to just kind of keep her laughing or smiling and let her know that she can be herself,” Geneva said. “She doesn't have to be Adeline Gray; she can just be my sister and let loose and relax. “If she's having a bad week, I feel like we try to do a little bit more laughing and a little bit more meditating and things that can just help her with her mental state. If she is having a great week, then we push through a little bit more and we're deﬁnitely competitive, so we challenge each other and it's fun.” South African sports agent Peet van Zyl has worked with Wayde van Niekerk since 2011 after ﬁrst seeing him compete at the Junior  “Waydeʼs general fitness levels were maintained but his training was done alone, so it was important to keep his mind strong” PEET VAN ZYL  World Championships. He could instantly see there was something special about him. “The natural talent was evident,” Van Zyl said. “It was a case of getting Wayde into a set-up to nurture the talent and let it blossom. The journey and progress have been wonderful, and now overcoming the injury setbacks from 2017 to be moving towards Tokyo is the next chapter we look forward to in Wayde’s career. “With Wayde, his general ﬁtness levels were maintained [during the lockdown] but all his training was done alone so it was important to keep his mind strong and dig into his mental side more.” Dutch-Iranian taekwondo master Manni Zareei was contacted by Dina Pouryounes when she sought asylum in the Netherlands. “We could not train in the dojang (training hall) any more, but luckily Dina has taekwondo mats and a taekwondo dummy in her home, so she could keep training,” Zareei said. “There are two of us helping Dina – her trainer, Ramin Padidar, trained Dina at her home. We had to ﬁnd sparring partners. That was hard. We went to Croatia for training camps to ﬁnd good quality sparring partners and to get her out of the home gym. “The hardest part has been staying focused when everything is uncertain. I saw Dina training hard and it paid off when she won the gold medal at the Soﬁa Open in March 2021.  This was her ﬁrst tournament after one year and she had a great performance at this world-ranking tournament. “For Dina, Tokyo is a dream come true. She is the hardest-working athlete I've ever worked with. I am so happy to be part of her Olympic dream.” Todoroki Manabu, assistant coach of the Japan men's handball team, restarted the team’s training camp in November, but the handball world has been badly affected by coronavirus. “We cancelled a lot of training games with good opponents and abandoned our ideas to have guest players,” Todoroki said. “Our plan has been destroyed by the pandemic completely. We have tried to train in as safe an environment as possible in the National Training Centre in Japan. Our camp was held under strict restrictions and we are happy that everything went very well. “We wanted to know whether the pandemic had a physical effect on our players, so we did some strength testing and the results were good. All of the players were in good shape, regardless of the situation. “We had worries about the mental side of our players because of the postponement of the Olympics and the uncertainty of competitions in the pandemic. Therefore we have continued our work on mental training with a sports psychiatrist. It was extremely successful as always and we are pleased with this training.” ■  3  1 Athletes like Dina Pouryounes relied on the support of their entourage during the pandemic. 2 The coaches of Japan's men's handball team had their plans turned upside down in 2020. 3 Geneva Gray (left) became her sister Adelineʼs training partner for the lockdown."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 40-title\" style=\"top:246px;left:45px\" src=\"/116/static/_content/40-title-1.png\">\n        <img class=\"halfScale 40-title\" style=\"top:558px;left:50px\" src=\"/116/static/_content/40-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg40Anim = new TimelineMax();\n          pg40Anim.staggerFromTo(cOf(\"40-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg40Anim.stop();\n        }\n        ",
    "searchText": "1 40  Feature: Tokyo 2020 preview  A GAMES LIKE NO OTHER ON THE EVE OF THE OLYMPIC GAMES TOKYO 2020, WHICH WILL TAKE PLACE FROM 23 JULY TO 8 AUGUST 2021, JAPANESE SPORTSWRITER SHINTARO KANO LOOKS AT HOW ORGANISERS ARE PLANNING TO DELIVER A SAFE AND SECURE EVENT FOR THE WORLD’S ATHLETES IN THE FACE OF UNPRECEDENTED CHALLENGES  1 The brand new Olympic sport of surﬁng will take place at Tsurigasaki Beach, 65km east of Tokyo."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "\n      <svg onclick=\"Publish.openGallery(['1.jpg', '2.jpg', '3.jpg', '4.jpg', '5.jpg', '6.jpg', '7.jpg', '8.jpg', '9.jpg', '10.jpg'])\" class=\"abs pointer pulse animatedpulse\" style=\"left:481px;width:50px; top:783px; height:50px;\" viewBox=\"0 0 160.62 157.733\" enable-background=\"new 0 0 160.62 157.733\">\n          <g>\n            <path fill=\"#fff\" d=\"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n              c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z\"/>\n            <path fill=\"#fff\" d=\"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n              c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n              h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n              c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n              M123.685,63.134h-20.209v-5.966h20.209V63.134z\"/>\n          </g>\n          <g>\n            <path fill=\"#fff\" d=\"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n              c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n              c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n              c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n              c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n              c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n              c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n              C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n              c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n              c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n              c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n              L154.856,78.867z\"/>\n          </g>\n        </svg>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 42-quote\" style=\"top:769px;left:264px\" src=\"/116/static/_content/42-quote-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg42Anim = new TimelineMax();\n          pg42Anim.staggerFromTo(cOf(\"42-quote\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg42Anim.stop();\n        }\n        ",
    "searchText": "1  T  he 24th March 2020. It has been well over a year since that spring day when the postponement of the Olympic Games Tokyo 2020, the ﬁrst-ever in history, was announced under the cloud of a global pandemic that would go on to have far-reaching consequences no one could have possibly imagined. To say that organising an Olympic Games in such a climate is challenging, would be an understatement. Hashimoto Seiko, President of the Tokyo Organising Committee of the Olympic and Paralympic Games (Tokyo 2020) and a seven-time Olympian, could not have better painted the picture with a single stroke. “Tokyo will be unlike any previous Olympic Games,” President Hashimoto told Olympic Review. “But what will not change is what is at its core – athletes giving their best, moving people with incredible performances.”  The Japanese government, Tokyo Metropolitan Government and Tokyo 2020, in conjunction with the IOC and International Paralympic Committee (IPC), have been working tirelessly to come up with the means and measures to organise a Games this summer that puts safety ﬁrst, and safety last. For President Hashimoto, it is precisely because of the difficult circumstances that the Olympic Games are worth holding, with its values mattering more than ever.  “We need to send a message of cooperation and coexistence through sport – through a safe and secure Tokyo 2020” HASHIMOTO SEIKO  “It is because the world is divided by the coronavirus that now we need to send a message of cooperation and coexistence through sport – through a safe and secure Tokyo 2020, the ﬁrst global-sized event since the pandemic began,” the Albertville 1992 bronze medallist said. “The challenging circumstances go on but we will leave no stone unturned in organising a safety-ﬁrst Games with countermeasures against the coronavirus a priority. We, as hosts of the Games, do this not only for the athletes and officials but also for the people of Japan.” IOC President Thomas Bach echoed President Hashimoto’s sentiments. His conﬁdence in Tokyo’s organisational ability has been and remains unwavering. “Tokyo remains the best prepared Olympic city ever,” President Bach said in his opening remarks at the 137th IOC Session in March 2021."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"addContentLink\" style=\"top:93px;left:37px;height:289px;width:434px;\">\n      <a href=\"https://olympics.com/ioc/tokyo-2020-playbooks\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          addContentLinks()\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "Olympic Review  43  Issue 116  2  3  “This is why our thanks and gratitude go in particular to the Government of Japan, the Tokyo Metropolitan Government, the Organising Committee, the athletes, the International Federations (IFs), the National Olympic Committees (NOCs), all our TOP Partners and Rights-Holding Broadcasters for their steadfast commitment to the success of the Olympic Games Tokyo 2020. “Thanks to this great determination and support of all our stakeholders, the question is  not ‘whether’ – the question is ‘how’ these Olympic Games will take place.” Enter the Playbooks. The Playbooks will be the go-to reference of the Games’ COVID-19 countermeasures for stakeholders, a series of handbooks written collaboratively by the Japanese and Tokyo governments, Tokyo 2020 and the IOC and IPC. They are science-driven, put together in consultation with the World Health Organization and infectious disease experts from across the world.  The ﬁrst edition of the Playbooks, consisting of six volumes in all, was published in February and updated in April. A third version was issued in June. The raft of measures in place include regular testing, social distancing, and other hygiene and logistical provisions that have been shown to minimise risk of infection and transmission. To make this work, both President Hashimoto and President Bach cannot emphasise enough the importance of the cooperation organisers receive from stakeholders – and in particular their commitment to adhere to the Playbooks. To coin one of President Hashimoto’s preferred phrases, Games participants will be part of “one team”. “The success of the Games hinges on the cooperation of the participants,” says the Tokyo 2020 President. “During their stay in Japan, we ask each and every one of them to arrive aware of the Playbooks so that a safe and secure Games are possible.” Adds the IOC President: “Providing more details about the operations that stakeholders can expect at Games-time, we have also remained ﬂexible to the evolving global situation, combining numerous countermeasures to create the safest possible environment. “Increased testing for athletes and stakeholders, before and during the Games, is one important example. We’re also encouraged by the growing number of vaccinations being administered throughout the world. “These tools will only work, however, if everyone shows solidarity and follows the guidelines. This is why those violating the rules can expect to be strictly dealt with in Tokyo. This is our commitment to the people of Tokyo and Japan, who are so kindly welcoming us to their city and country this summer.” Pulling off the daunting feat of hosting an Olympic Games during a global pandemic will be a legacy in itself, but Tokyo 2020’s longest lasting legacy may be embodied by none other than President Hashimoto herself.  1 Runners clear the water jump in the men's 3,000m steeplechase at the athletics test event. 2 The Playbooks are the go-to reference of Tokyo 2020's COVID-19 countermeasures for stakeholders. 3 Rhythmic gymnasts from Japan receive face masks after competing at the test event."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "44  Feature: Tokyo 2020 preview  The former speed skater and track cyclist was appointed Tokyo 2020 President in February 2021, promoted from her position as Japan’s Olympic and Paralympic minister. President Hashimoto – whose ﬁrst name is based on the Japanese word for Olympic ﬂame, thanks to her father who was so moved by the Opening Ceremony of Tokyo 1964 – spearheads an all-female leadership for Tokyo 2020, a point of huge signiﬁcance in a country where gender equality still has a way to go. She is being ﬂanked by Marukawa Tamayo, who succeeded her as Olympic and Paralympic minister; Sports Director Kotani Mikako, an Olympic medallist like President Hashimoto (artistic swimming, Seoul 1988) who has been tasked to lead Tokyo 2020’s gender equality team (see page 18); and none other than Koike Yuriko, the Tokyo Governor. With President Hashimoto’s experience as an Olympian and a politician, President Bach described her as “the perfect choice” to lead Tokyo 2020 through its ﬁnal preparations. Much of the legacy of Tokyo 1964 was concrete and could be hand-felt, in the form of infrastructure like the iconic venues Yoyogi National Stadium and Nippon Budokan, as well as the vast public transportation network which makes the country run; or the high economic growth the Games spurred nationwide throughout the 1960s and 1970s. The legacy of Tokyo 2020 may not be as physically tangible as those of 1964 but like  3  1 Protective measures at the Tokyo Stadium during the rugby sevens test event in April 2021. 2 John Coates, IOC Vice-President and Chair of the IOC Coordination Committee for Tokyo 2020.  1  gender equality – part of a grander Games vision of diversity and inclusion – the ripple effect could be felt for eternity in Japan. Recovery and reconstruction, also a theme for the Games, drove the start of the Olympic Torch Relay on 25 March from the J-Village in Fukushima Prefecture, which for years led the line in the most critical of times as the nation dealt with the aftermath of the 2011 Great East Japan Earthquake. The Torch Relay is set to pass through all 47 Japanese prefectures leading up to the 23 July lighting of the Olympic cauldron during the Opening Ceremony at the Olympic Stadium. For the athletes – who are the heart of any Games – as well as the National Federations  2  and IFs, words like challenging or difficult do not begin to describe their struggles in the last year with the virus virtually wiping out the global sporting calendar. Whether setting foot on the Olympic stage for the ﬁrst time or an established star like Simone Biles, Katie Ledecky or Teddy Riner, the run-up to these Games has been like no other for any athlete. The uncertainty surrounding Tokyo 2020 stemming from the pandemic has not been easy for the Japanese athletes in particular, who have been dedicating years to the Games in their efforts to make them an unforgettable career highlight in their home country. Nevertheless the likes of Momota Kento and Hasegawa Yui have kept their chins up, convinced that Tokyo 2020 can help lift peoples' spirits. For the sports that will be making their Games debut or are being reintroduced to the Olympic programme – karate, skateboarding, sport climbing, surﬁng and baseball/softball – they will still have their day in the sun. “I want to express my gratitude when I take the court at the Tokyo Olympics,” said Momota, the world no. 1 male badminton player carrying gold medal hopes for Japan, who attended high school just kilometres away from the nuclear power plant that melted down during the 2011 earthquake and tsunami. “It’s been exactly a decade since the earthquake and through my performances  1 Action from the volleyball test event at the Ariake Arena in May 2021. 2 A local climber tests out the wall at the Aomi Urban Sports Park. 3 The Nippon Budokan is the spiritual home of martial arts in Japan, and will host judo and karate."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "4 Members of Japan's women’s football team at the start of the Olympic Torch Relay in Fukushima."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "46  Feature: Tokyo 2020 preview  1  I hope I can inspire not just Fukushima but all the disaster areas. “I was able to turn the postponement into a positive,” he added of his experiences over the past 15 months. “I never saw it as a setback. The extra year afforded me the time to re-recognise I am who I am because of the support I receive from so many people.” Hasegawa, a footballer with Milan (in Italy) who has her eyes on the podium for Japan, said: “A lot of eyes will be on us so I want to play well and achieve good results. I played at the Olympic Stadium recently and it made me want to play in the gold medal match there. I’m determined to do it. “I know the entire world is suffering because of the pandemic. I hope I can help put a smile on people’s faces through sport, and give them something to look forward to. I owe it to all those who support me to make these Games as exciting as possible.” And President Bach is optimistic the Games will be exciting. He points to the 270-plus major sporting events that have been organised by IFs since September 2020, involving over 40,000 athletes with stringent protocols in place. More than 200,000 COVID-19 tests were conducted in all. “Not a single one of these events turned into a virus-spreader,” President Bach said. “So we have clear proof that big international sports events with a large number of  1 A view of the Olympic rings in front of Tokyo's famous Rainbow Bridge. 2 Hasegawa Yui hopes to lead the Japanese women's football team to a gold medal on home soil.  international participants can be organised while safeguarding the health of everyone. “This fact is even more signiﬁcant because none of these events could beneﬁt from vaccinations. In contrast, we are now in the very fortunate position that several vaccines are already widely in use. A considerable number of Olympic athletes are already or about to be vaccinated in time for Tokyo. This situation will continue to improve greatly the closer we get to the Opening Ceremony.” As of 12 May, more than 700 athletes and over 6,000 related staff had participated in  2  four test events held in Japan. These included the International Volleyball Games – Tokyo Challenge 2021, with 60 athletes from two countries (including 28 athletes from overseas), 19 overseas team officials, and 1,110 operational staff. The FINA Diving World Cup 2021, a qualifying competition for the Olympic Games Tokyo 2020, with 225 athletes from 46 countries and regions (including 212 athletes from overseas), 159 overseas team officials, and 410 operational staff. The Hokkaido – Sapporo Marathon Festival 2021, with 94 athletes from ﬁve countries (including six athletes from overseas), and 2,700 operational staff. The Ready Steady Tokyo – Athletics, with 350 athletes from seven countries and regions (including nine athletes from overseas), three overseas team officials, and 1,620 operational staff. Now, with a month to go to the Games’ opening, preparations for Tokyo 2020 are in the ﬁnal stretch. President Hashimoto, however, is already looking well beyond that. “I see it as Japan’s mission to make sure the experience of hosting Tokyo 2020 against this unprecedented backdrop does not go to waste and is built on for the Olympic and Paralympic movements. I am convinced the ‘Tokyo model’ will be a legacy for the ages and serve as a compass for the future of the Olympic Games and Paralympic Games.” ■"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:726px;left:225px;height:20px;width:278px;\">\n        <a href=\"https://olympics.com/tokyo-2020/en/fanzone/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top: 776px; left: 246px; height: 39px; width: 115px;\">\n        <a href=\"https://play.google.com/store/apps/details?id=org.olympic.app.mobile\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"    top: 776px; left: 383px; height: 39px; width: 103px;\">\n        <a href=\"https://apps.apple.com/us/app/olympics/id808794344\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          addContentLinks()\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "PLAY TOGETHER FOR OLYMPIC PRIZES ON FANZONE  AVAILABLE ON OLYMPICS.COM/TOKYO-2020 AND IN THE TOKYO 2020 MOBILE APP  Prize promotion open to residents of certain countries only. Age restrictions apply. No purchase necessary. See detailed terms and conditions for how to enter and rules on eligibility."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 48-title\" style=\"top:133px;left:43px\" src=\"/116/static/_content/47-title-1.png\">\n        <img class=\"halfScale 48-title\" style=\"top:294px;left:50px\" src=\"/116/static/_content/47-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg48Anim = new TimelineMax();\n          pg48Anim.staggerFromTo(cOf(\"48-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg48Anim.stop();\n        }\n        ",
    "searchText": "48  Feature: Tokyo 2020 preview  AQUATiCS  Tokyo’s time Olympic Review proﬁles the 33 sports that will be contested in 339 events across 42 venues during the Olympic Games Tokyo 2020  TOKYO AQUATiCS CENTRE; ODAiBA MARINE PARK; TATSUMi WATER POLO CENTRE 24 July-8 August Medal events: 49 For the ﬁrst time in Olympic history male and female swimmers will compete against each other in the inaugural 4×100m mixed medley relay. The men’s 800m freestyle and women’s 1500m freestyle are the other new events at Tokyo 2020. Marathon swimming, artistic swimming, diving and water polo complete the aquatics programme.  ARCHERY  YUMENOSHiMA PARK ARCHERY FiELD 23-31 July Medal events: 5 The archery programme boasts a new mixed team event alongside the men’s and women’s individual and team events. Shooting over a distance of 70m, athletes in the individual competitions are ranked from one to 64 after the qualifying round before competing in a knock-out, head-to-head tournament format that climaxes with the gold medal match.  ATHLETiCS  OLYMPiC STADiUM; SAPPORO ODORi PARK 30 July-8 August Medal events: 48 The track, ﬁeld and combined events will be staged in the Olympic Stadium in Tokyo while the Sapporo Odori Park will host the marathons and the race walks. The newest addition to the programme, the 4×400m mixed relay, takes place on the ﬁrst two days of the athletics competition and promises to be a thrilling spectacle.  BADMiNTON  MUSASHiNO FOREST SPORT PLAZA 24 July-2 August Medal events: 5 Making its debut on the Olympic programme in Barcelona in 1992, badminton consists of the men’s and women’s singles and doubles events, and the mixed doubles. Matches are played in a best-of-three games format and 21 points are required to win a game."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  49  Issue 116  BASKETBALL  SAiTAMA SUPER ARENA; AOMi URBAN SPORTS PARK 24 July-8 August Medal events: 4 One of the world’s most popular sports, basketball is characterised by the rapid transition between defence and attack. This year, in addition to the men’s and women’s traditional 12-team tournaments, basketball 3×3 – an exciting shortened format played on half of a standard court with one net – is to make its Olympic debut. It had been previously introduced at the Youth Olympic Games.  BOXiNG  KOKUGiKAN ARENA 24 July-8 August Medal events: 13 This year’s Olympic boxing programme features eight weight categories for men and ﬁve for women, an increase of two divisions from Rio 2016 for female boxers. Athletes in every semi-ﬁnal bout are guaranteed at least a bronze medal.  CANOE  KASAi CANOE SLALOM CENTRE; SEA FOREST WATERWAY 25 July-7 August Medal events: 16 Canoe slalom is split into the women’s and men’s canoe and kayak events and is staged on a 250m white water course, where up to 25 gates must be navigated. The women’s canoe single has replaced the men’s canoe double on the programme. Canoe sprint will take place during the second week of the Games and is a test of speed on ﬂat water, with races held over courses ranging between 200m and 1,000m in length. There are both canoe and kayak events.  CYCLiNG  ARiAKE URBAN SPORTS PARK; IZU MTB COURSE; MUSASHiNONOMORi PARK; FUJi INTERNATiONAL SPEEDWAY; IZU VELODROME 24 July-8 August Medal events: 22 The Olympic cycling programme is made up of BMX, mountain bike, road and track events. BMX racing sees six riders compete on a track featuring jumps and tight bends, while BMX freestyle is new to the Games and features one-minute performances of tricks scored on execution and creativity. Staged on an off-road course with sweeping views of Mount Fuji, the men’s and women’s mountain bike races are contested over 2.1km laps and elevations of up to 150m. Road cycling will consist of a men’s and women’s road race and time trial, while there are six track cycling events for men and women: keirin, omnium, team pursuit, sprint, team sprint, and the newly-restored madison.  EQUESTRiAN  BAJI KOEN; SEA FOREST CROSS-COUNTRY COURSE 24 July-7 August Medal events: 6 Equestrian features three disciplines, each with individual and team events. Dressage is where horse and rider are expected to perform from memory a series of predetermined movements. Points ranging from zero to 10 are awarded for athletic ability, execution and elegance. Jumping requires horse and rider to clear obstacles, up to 1.65m high, in the quickest possible time. Eventing is a multi-discipline format involving dressage, cross-country and jumping.  FENCiNG  MAKUHARi MESSE HALL 24 July-1 August Medal events: 12 One of the few sports to have featured at every modern Olympic Games, three disciplines make up fencing: foil, épée and sabre. At Tokyo 2020, each discipline will feature an individual and a team event for both men and women. Competitors’ blades and clothing are wired to an electronic, automated scoring system to indicate a successful hit."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "50  Feature: Tokyo 2020 preview  FOOTBALL  HOCKEY  21 July-7 August Medal events: 2 Spread across seven different venues and beginning with the group stage, men compete in a 16-team tournament and women in a 12-team tournament. Yokohama will stage the men’s gold medal match and Tokyo the women’s equivalent.  24 July-6 August Medal events: 2 A permanent feature on the Olympic programme from Amsterdam 1928 onwards, ﬁve group stage matches await the 12 hockey teams in the men’s and women’s tournaments. The top four in each group progress to the knockouts and will battle for medals at the Oi Hockey Stadium.  GOLF  JUDO  29 July-7 August Medal events: 2 Golf made an unforgettable return to the Olympic programme at Rio 2016, having previously not featured since 1904. There are individual events for men and women, which are played over 72 holes across four days. The format is stroke play with the gold medals awarded to the golfers recording the lowest cumulative score.  24-31 July Medal events: 15 Judo gained worldwide popularity after entering the Olympic programme at Tokyo 1964 and makes a highly anticipated return to the same venue, the Nippon Budokan. Alongside the 14 individual, weight-based events for men and women (seven each), three male and three female judokas will join forces for a new mixed event.  GYMNASTiCS  MODERN PENTATHLON  24 July-8 August Medal events: 18  5-7 August Medal events: 2 One of the most varied Olympic events, modern pentathlon features fencing, a 200m freestyle swim, show jumping and a combined laser-run (running and shooting) component. The ﬁrst pentathlete to cross the ﬁnish line in the laser-run is the gold medallist.  TOKYO STADiUM; SAPPORO DOME; SAiTAMA STADiUM; MiYAGi STADiUM; INTERNATiONAL STADiUM YOKOHAMA; IBARAKi KASHiMA STADiUM; OLYMPiC STADiUM  KASUMiGASEKi COUNTRY CLUB  ARiAKE GYMNASTiCS CENTRE  Gymnastics is divided into three disciplines: artistic, trampoline and rhythmic. Male and female athletes both perform the vault and the ﬂoor exercises. Men also compete on the horizontal bar, pommel horse, parallel bars and rings, and women on the uneven bars and balance beam. Rhythmic gymnastics involves artistic routines set to music. Trampoline gymnasts perform two routines, one compulsory and one voluntary, and are scored on execution and difficulty.  HANDBALL  YOYOGi NATiONAL STADiUM 24 July-8 August Medal events: 2 Contested on a court measuring 40×20m, handball matches feature seven players per side. Athletes can hold the ball for a maximum of three seconds and take three steps while in possession. The menʼs and womenʼs events will each feature 12 teams.  Oi HOCKEY STADiUM  NiPPON BUDOKAN  MUSASHiNO FOREST SPORT PLAZA; TOKYO STADiUM  ROWiNG  SEA FOREST WATERWAY 23-30 July Medal events: 14 Tokyo Bay is the setting for the rowing competition, where for the ﬁrst time in Olympic history there will be full gender equality in the number of rowers and events. In Japan, the women’s coxless four has replaced the men’s lightweight coxless four, meaning there are now seven events each for men and women. In sweeping races, rowers use a single oar, while they have two for the sculling events."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  51  Issue 116  RUGBY SEVENS  TAEKWONDO  26 31 July Medal events: 2 Rugby returned to the Olympic programme at Rio 2016 with the new sevens format. Featuring frenetic 14-minute matches comprised of two seven-minute halves, 12 teams line up for the pool round in both the men’s and women’s tournaments. Teams are placed into three pools of four teams and play each other once. The top two from each pool progress to the knock-out round with the two highest-ranked third-place teams.  24 27 July Medal events: 8 Taekwondo contests consist of three rounds of two minutes each with a 60-second break between each round. There are four weight classes respectively for men and women, while electronic sensors in the athletes’ protective clothing register successful kicks and punches.  TOKYO STADiUM  SAiLiNG  ENOSHiMA YACHT HARBOUR 25 July-4 August Medal events: 10 There are six different classes of boat that make up the sailing programme for Tokyo 2020. Points are awarded on a sliding scale in each event, with one point to the race winner, meaning the eventual gold medallist is the boat with the lowest cumulative points tally.  MAKUHARi MESSE HALL  TENNiS  ARiAKE TENNiS PARK 24 July-1 August Medal events: 5 The 16th edition of tennis at the Olympic Games, this year’s event features men’s and women’s singles and doubles, as well as mixed doubles for a third successive Games. All singles matches are the best-of-three sets, while doubles matches will be decided by a ﬁrst-to-10-points tiebreak in place of a third set.  TRiATHLON  ODAiBA MARiNE PARK  SHOOTiNG  ASAKA SHOOTiNG RANGE 24 July-2 August Medal events: 15 A test of skill and nerve, there are three disciplines in shooting: riﬂe, pistol and shotgun. Riﬂe and pistol involve stationary targets, while shotgun features moving targets. Designed to promote gender equality, Tokyo 2020 will feature three new events: the 10m air riﬂe mixed team, the 10m air pistol mixed team, and the trap mixed team.  26-31 July Medal events: 3 A mixed team relay, featuring two male and two female athletes, is an exciting new addition to the triathlon programme. The two individual races consist of a 1.5km swim, 40km bike ride and 10km run, while in the team event each athlete will complete a short-course triathlon (300m swim, 7.4km bike ride, 2km run). There are no breaks or heats, and the ﬁrst athlete to cross the ﬁnish line is the winner.  VOLLEYBALL TABLE TENNiS  ARiAKE ARENA; SHiOKAZE PARK  TOKYO METROPOLiTAN GYMNASiUM  24 July-8 August Medal events: 4  24 July-6 August Medal events: 5 In addition to the men's and women’s singles and team events, Tokyo 2020 will stage a brand new mixed doubles event. All ﬁve tournaments are single-elimination format, with the semi-ﬁnal losers competing for the bronze medal.  There are six players per side on an indoor 18×9m court, and volleyballs can reach speeds exceeding 130km per hour. Beach volleyball uses a slightly smaller court and features two players per team, who need two sets to win a match. The discipline will be staged at a temporary venue in Shiokaze Park."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 52-title\" style=\"top:330px;left:43px\" src=\"/116/static/_content/52-title-1.png\">\n        <img class=\"halfScale 52-title\" style=\"top:385px;left:43px\" src=\"/116/static/_content/52-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg52Anim = new TimelineMax();\n          pg52Anim.staggerFromTo(cOf(\"52-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg52Anim.stop();\n        }\n        ",
    "searchText": "52  Feature: Tokyo 2020 preview  WEiGHTLiFTiNG  WRESTLiNG  24 July-4 August Medal events: 14 One of the oldest competitive activities in the world, Tokyo 2020 will see weightlifting feature a gender-equal seven male and seven female weight categories for the ﬁrst time. Competitors are scored by combining their heaviest lifts in the snatch and two-stage clean and jerk.  1-7 August Medal events: 18 Considered the world’s oldest sport, wrestling is contested on a circular mat nine metres in diameter. The aim of freestyle wrestling is to pin both shoulders of your opponent to the ﬂoor for one second using any part of the body. Greco-Roman wrestlers, on the other hand, can only use their upper bodies to pin their rival.  TOKYO INTERNATiONAL FORUM  New in Tokyo Five thrilling new sports have been added to the Olympic programme for Tokyo 2020  BASEBALL/SOFTBALL  YOKOHAMA BASEBALL STADiUM; FUKUSHiMA AZUMA BASEBALL STADiUM 21 July-7 August Medal events: 2 The return of men’s baseball and women’s softball to the Olympic Games for the ﬁrst time since 2008 will see six countries compete in Yokohama and Fukushima in each of the events. Both disciplines are focused on the contest between the pitcher and batter, played out on a diamond playing surface. Softball balls are slightly bigger than those used in baseball.  MAKUHARi MESSE HALL  SKATEBOARDiNG  ARiAKE URBAN SPORTS PARK 25 July-5 August Medal events: 4 Street skateboarding features a course with stairs, handrails, curbs, benches and walls with competitors performing tricks marked on the degree of difficulty, height, speed and originality. Park skateboarding takes place on a hollowed-out course with sloping sides to enable mid-air tricks.  SPORT CLiMBiNG  AOMi URBAN SPORTS PARK 3-6 August Medal events: 2 Climbers will compete in a combined event featuring three disciplines: speed, bouldering and lead. Speed climbing is a straight race up a 15m wall; bouldering is a series of ﬁxed routes without ropes up a 4m wall; and lead climbing involves a 15m tethered climb, which must be completed within six minutes. The best climber overall will claim the gold medal.  KARATE  NiPPON BUDOKAN 5-7 August Medal events: 8 Making an historic debut at the Olympic Games in Tokyo, karate is an ancient martial art with two disciplines, and four medal events each for men and women. “Kumite” is the combat form featuring three-minute bouts with points scored for successful kicks and punches, while “Kata” is a solo, choregraphed routine with points awarded by judges.  SURFiNG  TSURiGASAKi SURFiNG BEACH 25 July-1 August Medal events: 2 A panel of ﬁve judges will score each surfer on every wave ridden based on the difficulty and variety of their manoeuvres. Each session lasts up to 35 minutes. Only a surfer’s two highestscoring waves count towards their ﬁnal points total."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  53  Issue 116  Skateboarding will make its Olympic debut at the Ariake Urban Sports Park."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 54-title\" style=\"top:104px;left:43px\" src=\"/116/static/_content/54-title-1.png\">\n        <img class=\"halfScale 54-title\" style=\"top:255px;left:43px\" src=\"/116/static/_content/54-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg54Anim = new TimelineMax();\n          pg54Anim.staggerFromTo(cOf(\"54-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg54Anim.stop();\n        }\n        ",
    "searchText": "54  Feature: Tokyo 2020 preview  Jewel in the East  HERITAGE ZONE Featuring 10 central venues, ﬁve of which have an Olympic pedigree, this area celebrates the lasting legacy created by the Olympic Games Tokyo 1964.  OLYMPiC STADiUM The centrepiece of the Olympic Games Tokyo 2020, the arena in the Meiji Jingu Gaien district is an update on the beloved old National Stadium, which served as the main venue for Tokyo 1964. The stadium will host the Opening and Closing Ceremonies, as well as athletics and football, and will serve as a sporting and cultural hub after the Games. The roof is made partly from cedar and larch sourced from all 47 of Japan’s prefectures.  The majority of the Olympic Games Tokyo 2020 will take place in two adjacent areas of Tokyo, both framed by the stunning urban backdrop of the iconic Japanese capital  TOKYO METROPOLiTAN GYMNASiUM Originally constructed to host the 1954 World Wrestling Championships, it was repurposed to stage gymnastics and water polo at Tokyo 1964. During Tokyo 2020, the building will be home to table tennis.  YOYOGi NATiONAL STADiUM Famed for its suspended roof design, the Yoyogi National Stadium was constructed to stage the aquatics and basketball events in 1964. It has since been used for a variety of sports and will host handball at Tokyo 2020.  NiPPON BUDOKAN 1  Renowned as the spiritual home of martial arts in Japan, the Budokan hosted the ﬁrst-ever Olympic judo events in 1964 and this year will welcome karate along with judo once again. Built on the same grounds as the 15th century Edo Castle, its design was inspired by an ancient temple as well as Mount Fuji.  TOKYO INTERNATiONAL FORUM Located in the heart of Tokyo’s ﬁnancial district and boasting a striking glass façade, the Forum is a multi-purpose exhibition centre which attracts millions of visitors annually. Work on the building was completed in 1996 and this year it will host the Olympic weightlifting events.  1 The Tokyo Aquatics Centre will open to the Japanese public after the Games have concluded. 2 Baji Koen is one of a number of legacy venues from the Olympic Games Tokyo 1964."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  55  Issue 116  HOME FROM HOME The Olympic Village in the Harumi waterfront district is located at the intersection of the Heritage and Tokyo Bay zones, placing it both physically and symbolically at the heart of the Games. A stunning development of 23 tower blocks on an artiﬁcial island, the Village will grant the athletes spectacular views of the host city and will be redeveloped into apartments after the Games.  2  KOKUGiKAN ARENA  MUSASHiNONOMORi PARK  Boxing will take place at the Kokugikan in 2021, although the venue is traditionally associated with sumo wrestling. The interior of the building is designed in a bowl shape to afford spectators uninterrupted views irrespective of where they are seated.  Selected as the starting point for cycling’s road races, the park is located in one of Tokyo’s quieter suburbs in the west of the city and measures 340,000 square metres.  BAJi KOEN The park hosted the equestrian events at Tokyo 1964 and will again stage the dressage, eventing and jumping competitions 57 years later. The venue was renovated in 2019 and will be operated by Japan’s National Federation for Equestrian after the Games.  A stunning waterside location with panoramic views of the city’s renowned Rainbow Bridge, the Bay Zone is a symbol of innovative urban development. It is home to 14 venues for the Olympic Games Tokyo 2020, as well as the international media within the striking “Big Sight” exhibition centre.  MUSASHiNO FOREST SPORT PLAZA  TOKYO AQUATiCS CENTRE  The ﬁrst permanent building ﬁnished ahead of the Games, the Plaza will host badminton and modern pentathlon. The arena’s swimming pool, gym, multi-use sports area and two ﬁtness studios will all be open to the public post-Games and accessible to all.  Featuring a moveable ﬂoor and walls that can change the dimensions of the main pool, the state-of-the-art facility will be open to the public after the Games have concluded. During the Games the arena will host the swimming, diving and artistic swimming events.  ARiAKE ARENA  ARiAKE GYMNASTiCS CENTRE  ODAiBA MARiNE PARK  A temporary venue in the northern part of Tokyo’s Ariake district, the centre boasts wood throughout the structure and will stage the rhythmic, artistic, and trampoline gymnastics  The triathlon and marathon swimming events will take place inside this stunning park, which features a 12.5m replica of the Statue of Liberty.  TOKYO STADiUM Football, modern pentathlon and rugby will all grace the stadium during the Games. Opened in 2001, it is now home to football club FC Tokyo and hosted the opening ceremony of the 2019 Rugby World Cup.  TOKYO BAY ZONE  events. Post-Games, the seating will be removed and the building converted into a permanent exhibition hall.  ARiAKE URBAN SPORTS PARK This stunning waterfront facility close to the Olympic Village will welcome Olympic debutants BMX freestyle and skateboarding.  ARiAKE TENNiS PARK Opened in 1983 on the site of a former golf course, the park boasts show, indoor and outdoor courts and will host the nine-day tennis tournament during the Games. The arena’s centre court, known as the Ariake Coliseum, has a retractable roof.  Sited on the artiﬁcial island of Odaiba, accessed from central Tokyo by the famed Rainbow Bridge, the arena will be the home of Olympic volleyball. The sleek, modern-looking building will then be repurposed as a sporting and cultural centre."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "56  Feature: Tokyo 2020 preview  1  THE BEAUTIFUL GAME The Olympic football tournaments will be hosted throughout Japan, with ﬁve world-class venues beyond Tokyo hosting a total of 53 matches between them. These include the International Stadium Yokohama, which hosted the 2002 FIFA World Cup Final, and the Miyagi Stadium situated in the disaster-hit Tohoku region.  SAPPORO DOME Sapporo  SHiOKAZE PARK  Oi HOCKEY STADiUM  A gloriously green area with 13,000 trees, Shiokaze is the largest park on the waterfront area of Odaiba and will stage beach volleyball.  This brand-new venue has three artiﬁcial pitches and will become a multi-sport facility after the Games.  AOMi URBAN SPORTS PARK  KASAi CANOE SLALOM CENTRE  Situated close to the Ariake Urban Sports Park to form a larger, youth-focused urban hub, the park will stage the Olympic debuts of 3×3 basketball and sport climbing.  The ﬁrst man-made course to be built in Japan, the centre will serve as a wide-ranging aquatics facility and leisure destination after it has staged the Olympic canoe slalom events.  SEA FOREST WATERWAY  MiYAGi STADiUM Rifu  IBARAKi KASHiMA STADiUM Kashima  YUMENOSHiMA PARK ARCHERY FiELD  Canoe sprint and rowing will take place at this attractive waterfront location. The waterway is 2,335m long and 198m wide and will host international regattas after the Games.  Built on a former landﬁll site in the Tokyo Bay Zone, the Archery Field complex features a grandstand and a warm-up area shaped like a bow. Archers from local clubs will have access to the venue after the Games.  SEA FOREST CROSS-COUNTRY COURSE This venue offers superb views of Tokyo Bay and will stage the cross-country element of equestrian’s eventing discipline.  SAiTAMA STADiUM Saitama  TATSUMi WATER POLO CENTRE Opened almost three decades ago to serve as an aquatics hub for the city, the centre is an elegant building made of reinforced concrete and steel, and has witnessed a number of swimming world records broken in its pool.  INTERNATiONAL STADiUM YOKOHAMA Yokohama  MAKUHARi MESSE HALL  1  Located in Chiba city to the east of Tokyo, Makuhari Messe is a large convention centre and entertainment hub which will stage wrestling, taekwondo and fencing during the Games.  1 Oi Hockey Stadium (above) and the Tatsumi Water Polo Centre (left) are located in the Tokyo Bay Zone. 2 A test event for the mountain bike course was staged in the city of Izu in October 2019."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  57  Issue 116  2  BEYOND TOKYO Eleven venues outside the capital have been selected to be part of the Games.  FUJi INTERNATiONAL SPEEDWAY The ﬁnishing point for the cycling road races, s, as well as the venue for the individual time trials, the circuit is 2.8km long and has previously staged the Japanese Grand Prix.  FUKUSHiMA AZUMA BASEBALL STADiUM The stadium is located 217km north of Tokyo o in the Tohoku region which was badly hit by the 2011 tsunami. Several baseball/softball group stage matches will be staged here as part of the organisers’ ambition to bring the Olympic spirit to disaster-affected areas.  KASUMiGASEKi COUNTRY CLUB Opened in 1929, this historic club is 56km away from the main Olympic complex and will be the venue for the men’s and women’s golf events.  TSURiGASAKi SURFiNG BEACH Looking out over the North Paciﬁc Ocean and 65km east of Tokyo, the beach is within the Chiba Prefecture and is the venue for the e debut of surﬁng as an Olympic sport.  YOKOHAMA BASEBALL STADiUM  ENOSHiMA YACHT HARBOUR  Home to a professional baseball team, the stadium opened in 1978 and will stage the gold medal matches of the Olympic baseball/ l/ softball tournaments.  The sailing centre during Tokyo 1964, the harbour on Sagami Bay in Kanagawa Prefecture will fulﬁl the same role this year.  SAPPORO ODORi PARK Situated in the Olympic Winter Games host city of Sapporo on the northern island of Hokkaido, the park is a 1.5km rectangular open space which was selected to stage the e marathon and race walking events because of its cooler climate.  SAiTAMA SUPER ARENA One of Japan’s largest multi-purpose venues, s, the arena is 30km north of the capital and willll host the basketball events. It will then revert back to serve as a multi-sport venue staging among others basketball, professional wrestling, MMA, volleyball, tennis and ice hockey.  IZU VELODROME Japan’s national cycling training centre 130km south of Tokyo, the velodrome was opened in 2011 and has undergone a signiﬁcant upgrade ahead of the Games.  IZU MTB COURSE The off-road track in Izu City in Shizuoka Prefecture for the mountain bike races measures 4.1km in length, with elevations of up to 150m.  ASAKA SHOOTiNG RANGE One of Tokyo 2020’s closest outlying venues, the range also hosted the shooting events in 1964."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 58-title\" style=\"top:107px;left:43px\" src=\"/116/static/_content/58-title-1.png\">\n        <img class=\"halfScale 58-title\" style=\"top:232px;left:45px\" src=\"/116/static/_content/58-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg58Anim = new TimelineMax();\n          pg58Anim.staggerFromTo(cOf(\"58-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg58Anim.stop();\n        }\n        ",
    "searchText": "58  Feature: Tokyo 2020 preview  OLYMPiC PARTNERS AT THE TOP OF THEiR GAME The Worldwide Olympic Partners will play a central role in the safe, secure and successful staging of Tokyo 2020, as they do during each and every edition of the Olympic Games  W  hen the eyes of the world fall on Tokyo this summer during the Olympic Games, they will be focused on inspiring performances by all the athletes. But behind the scenes, the success of the Games will be heavily reliant on another elite group: the Worldwide Olympic Partners. As members of The Olympic Partners (TOP) programme – the highest level of Olympic sponsorship – these leading multinational companies provide crucial technical services, products, expertise, and funding that ensure the Games run as smoothly and efficiently as possible, enabling more athletes from more National Olympic Committees (NOCs) to compete on the world’s biggest sporting stage. According to IOC President Thomas Bach, the importance of the Worldwide Olympic Partners cannot be overstated – especially as the sporting movement continues to recover from the impact of the COVID-19 pandemic.  “In these unprecedented times, the confidence of our Worldwide Partners is now more important than ever,” he says. “The long-term support of our global partners means the Olympic Movement is able to enjoy financial stability and operational support, which helps to overcome challenges, such as those the world has faced over the last 18 months. And by redistributing 90 per cent of the revenues it generates, the IOC is also able to support sport and athletes globally, all year round.” The TOP programme was launched in 1985, granting category-exclusive Olympic marketing rights to a select group of global partners, and has since provided a major source of revenue for the Olympic Movement. This income is distributed directly to sports organisations at all levels, including the NOCs from all across the globe, which use these funds to help develop and support their athletes, enabling  them to send a team to the Olympic Games. The programme has therefore been a significant factor behind the increased universality of the Olympic Games, with more athletes from more NOCs now able to compete. But the TOP programme is about more than just money. The Worldwide Olympic Partners also play an integral role in the actual staging of the Games themselves, contributing products, services and expertise, while their global Olympic marketing campaigns help to promote both the Games and the Olympic values, and increase support for the Olympic athletes. It is this operational support that makes the Partners so valuable to the Games, and the Olympic Movement as a whole, according to Jiří Kejval, Chair of the IOC Marketing Commission. “Without the support of our Worldwide Olympic Partners, without their technology, expertise, people, services, products and financing, the Olympic Games would simply not be possible,” he says. “The Partners’ support allows more athletes from more countries to compete in the Games, and they deliver the services and resources that are the driving force of the Olympic Movement.” In Tokyo, this support will be as varied as it is widespread. From supplying cutting-edge technology to the Games venues to providing a range of industry-leading products that are vital for day-to-day operations and COVID-19 countermeasures, the contributions of the Worldwide Olympic Partners will be behind every inspiring performance and every unforgettable moment. ■  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "2  1 A view of Tokyoʼs famous Rainbow Bridge and the illuminated Olympic rings. 2 Tokyo 2020’s Olympic mascot Miraitowa."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 60-title\" style=\"top:189px;left:96px\" src=\"/116/static/_content/60-title-1.png\">\n        <img class=\"halfScale 60-title\" style=\"top:339px;left:177px\" src=\"/116/static/_content/60-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg60Anim = new TimelineMax();\n          pg60Anim.staggerFromTo(cOf(\"60-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg60Anim.stop();\n        }\n        ",
    "searchText": "60  Through the Lens  01  THROUGH FOLLOWING THE HISTORIC DECISION TO POSTPONE THE OLYMPIC GAMES ON 24 MARCH 2020, THE EFFORTS OF ALL STAKEHOLDERS TURNED TOWARDS DELIVERING A SAFE EVENT FOR ALL IN 2021. ATHLETES CONTINUED TRAINING AND IN SOME CASES NEEDED TO SECURE THEIR QUALIFICATION, WHILE THE OLYMPIC TORCH RELAY AND OTHER CEREMONIES WERE REORGANISED AND MADE SUITABLE FOR A CORONAVIRUS-IMPACTED WORLD  THE LENS"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg61.jpg",
    "zoom": null,
    "content": "\n      <a href=\"https://www.youtube.com/watch?v=ui4NKt-Z5Ks\" target=\"_blank\">\n        <svg class=\"abs pulse animatedpulse pointer\" style=\"width: 35px; height: 35px; left: 387px; top: 517px; overflow: visible;\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n          <circle fill=\"none\" stroke=\"#fff\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n          <polyline fill=\"#fff\" points=\"558,356 207,563 207,117 \"/>\n        </svg>\n      </a>\n    ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "61  01.  POSTPONEMENT OF THE GAMES ANNOUNCED (MARCH 2020) On 24 March 2020, IOC President Thomas Bach joined a call with the Japanese Prime Minister at the time, Abe Shinzo, and members of the Tokyo Organising Committee of the Olympic and Paralympic Games (Tokyo 2020), and concluded that the Olympic Games should be rescheduled, agreeing that the new dates should be no later than summer 2021. As the news spread around the world, the Olympic rings continued to illuminate Tokyo and provide a symbol of hope.  02.  ATHLETES TRAINING AT HOME (JUNE 2020) As the profound impact of COVID-19 became apparent and lockdowns were imposed across the globe, athletes found themselves having to adapt their training schedules at short notice and the goalkeeper of Argentina’s national hockey team, Juan Manuel Vivaldi, was no exception. The Rio 2016 gold medallist trained at home alone for several months, before returning to team training sessions in June as restrictions were relaxed.  02 03  03.  ONE YEAR TO GO (JULY 2020) With the new dates for the Olympic Games established, the one year to go ceremony took place on 23 July 2020 at the National Stadium in Tokyo. Japanese swimmer Ikee Rikako held a lantern carrying the Olympic ﬂame and highlighted the efforts of essential workers worldwide. Having recovered from leukaemia, the inspirational Ikee has since qualiﬁed for Tokyo 2020."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg62.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top: 411px;left: 70px;height: 16px;width: 158px;\">\n          <a href=\"https://olympics.com/en/video/day-1-of-the-tokyo-2020-olympic-torch-relay-in-fukushima\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top: 616px;left: 70px;height: 16px;width: 123px;\">\n          <a href=\"https://iocnewsroom.com/video/prior-to-100-days-to-go-to-tokyo-2020-ioc-sees-host-as-best-prepared-in-olympic-history/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "62  01.  Through the Lens  RETURN TO SPORT (FEBRUARY 2021) In late 2020, many sports had returned to action with countermeasures in place to help keep athletes and other participants safe. Qualiﬁcation for Tokyo 2020 and other events was still on the line, and while venues around the world could not welcome spectators, the level of competition did not drop. In the FIBA EuroBasket Qualiﬁers, Montenegro hosted Germany in Podgorica, with the home side triumphing 82-75.  02.  OLYMPIC TORCH RELAY (MARCH 2021) The Olympic Torch Relay got underway on 25 March 2021 from the J-Village National Training Centre in Fukushima Prefecture. The torch has since continued its journey across the length and breadth of Japan, providing a symbol of hope while passing World Heritage Sites and other famous locations. Here, the torch can be seen travelling by boat through Tochigi on the fourth day of its tour through the country.  03.  100 DAYS TO GO (APRIL 2021) On 14 April 2021, the Omega countdown clock at Tokyo station displayed the milestone of 100 days to the start of the Opening Ceremony. On the same day, the Olympic rings were unveiled on Mount Takao, and a ceremony was held in downtown Tokyo to mark the occasion.  01 02"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg63.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "03"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg64.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "01  01.  TEST EVENTS (APRIL 2021) With the Games fast approaching, test events took place across multiple sports as preparations continued. These events are organised by International Federations, National Federations and Tokyo 2020 as a dress rehearsal to ensure the Olympic competitions can operate safely and successfully for all involved. One such test event was held for track cycling at the Izu Velodrome on the 250m wooden cycling track."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg65.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  02.  Issue 116  50 DAYS TO GO (JUNE 2021) To mark 50 days until the Opening Ceremony, Tokyo 2020 revealed the podium, theme music, costumes and medal trays that will be used during the victory ceremonies. The event took place at the Ariake Arena, which will host volleyball this summer, and was live streamed to a global audience.  65"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg66.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 66-title\" style=\"top:95px;left:45px\" src=\"/116/static/_content/66-title-1.png\">\n        <img class=\"halfScale 66-title\" style=\"top:289px;left:49px\" src=\"/116/static/_content/66-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg66Anim = new TimelineMax();\n          pg66Anim.staggerFromTo(cOf(\"66-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg66Anim.stop();\n        }\n        ",
    "searchText": "66  Feature: Postponement Lessons  THE TOKYO POSTPONEMENT LESSONS LEARNED FOR THE OLYMPIC MOVEMENT"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg67.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 67-quote\" style=\"top:383px;left:408px\" src=\"/116/static/_content/68-quote-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg67Anim = new TimelineMax();\n          pg67Anim.staggerFromTo(cOf(\"67-quote\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg67Anim.stop();\n        }\n        ",
    "searchText": "Olympic Review  67  Issue 116  FACED WITH THE UNPRECEDENTED CHALLENGE OF RESCHEDULING THE OLYMPIC GAMES TOKYO 2020 DURING A GLOBAL PANDEMIC, THE IOC AND ITS STAKEHOLDERS HAVE COME TOGETHER TO CREATE MANY POSITIVE SOLUTIONS THAT WILL LAY A STRONG FOUNDATION FOR THE GAMES OF THE FUTURE. BY STEPHEN WILSON  “The coronavirus crisis has changed our world in fundamental ways. The world will never again be like it was before. Even once we have ﬁnally overcome the health crisis, we will face the far-reaching social, ﬁnancial, economic and political consequences. As leaders of the Olympic Movement, we must prepare ourselves for this new world.”  T Rescheduling the Olympic Games Tokyo 2020 has been an enormous undertaking for all Olympic Movement stakeholders.  hose words, spoken by IOC President Thomas Bach during the virtual 137th IOC Session in March 2021, summed up the impact of the COVID-19 pandemic that upended the world and forced the historic postponement of the Olympic Games Tokyo 2020. They also underscored the crucial importance of the lessons learned from the one-year delay and how they can be applied to the Olympic Games in the future. From cost-saving simpliﬁcation measures to scaledback service levels to creative digital engagement programmes, the postponed Tokyo Games have opened the door for new ways of thinking by future Organising Committees for the Olympic Games (OCOGs). When the ﬁrst cases of a mysterious new virus emerged in late 2019, no one could have predicted that the contagion would sweep the globe and reshape society so profoundly"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg68.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "68  Feature: Postponement Lessons  that it remains impossible to know when daily life will ever return to “normal”. For the Olympic Movement, the pandemic led to the conclusion in March 2020 that Tokyo 2020 should be put back by a full year – the ﬁrst-ever postponement in the 124-year history of the modern Olympic Games. The delay threw up a slew of logistical, ﬁnancial, legal, political and sporting challenges for the IOC, Japanese organisers, National Olympic Committees (NOCs), International Federations (IFs), athletes, broadcasters, sponsors and other key players. Rescheduling the most complex peacetime event on the planet would be a massive undertaking, unlike anything done before. “The Olympic Movement is facing an unprecedented challenge,” President Bach said following the postponement. “This new situation will need all our solidarity, creativity, determination and ﬂexibility. We shall all need to make sacriﬁces and compromises. Extraordinary circumstances call for extraordinary measures. This situation requires every one of us to do our part, and this applies to all of us, including the IOC.” The priorities for rescheduling the Olympic Games were daunting. They included: 1 Tokyo 2020 President Hashimoto Seiko speaks to the IOC Executive Board during a virtual meeting. 2 All of the Olympic venues were secured for 2021, including the Olympic Village. 3 Key decisions were made in March 2021 at the IOC Session, which was held in a virtual format.  3  • agreeing on new dates for the Games in 2021; • reshuffling the international sports calendar; • resecuring all the Olympic venues including the Olympic Village; • reconﬁrming the competition schedule for 33 sports; • determining and covering the additional costs incurred by the postponement; • devising and implementing steps to simplify the Games and reduce costs; • maintaining the staff, workforce and volunteers; and • developing and applying measures to mitigate the virus in order to ensure safe and secure Games for everyone involved.  In many ways, it was almost like starting from scratch. “It took hard work, absolute dedication, thorough planning and execution,” said Christophe Dubi, the IOC’s Olympic Games Executive Director. The past year has involved a series of crucial decisions that required full unity and collaboration among the IOC, Japanese government, Tokyo Metropolitan  1  Government and the Tokyo Organising Committee of the Olympic and Paralympic Games (Tokyo 2020) to keep the project moving forward in the circumstances. Despite the relentless surge of the virus and its new variants across the world, the IOC and its partners managed to ﬁt all the pieces of the Tokyo Games into place for the event to go ahead 12 months later. “From an Olympic Movement standpoint, I saw great unity and a true convergence of interests and objectives,” Dubi said. “The lesson is that the Movement is very strong; through rough seas, all hands were on deck with the best spirit and intent.” The process began with the monumental decision announced on 24 March 2020 to postpone the Games because of the escalating pandemic that had sent much of the world into lockdown. The determination to delay the Games for one year came after the IOC, its Japanese partners and other stakeholders all agreed that cancelling the Games was not an option. “There was never any talk of cancellation amongst us at our level,” said John Coates, IOC Vice-President and Chair of the IOC Coordination Commission for the Olympic Games Tokyo 2020. “We were very steadfast.”"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg69.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 69-quote\" style=\"top:789px;left:45px\" src=\"/116/static/_content/69-quote-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg69Anim = new TimelineMax();\n          pg69Anim.staggerFromTo(cOf(\"69-quote\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg69Anim.stop();\n        }\n        ",
    "searchText": "Olympic Review  2  For Dubi, the crisis illustrated the global importance and relevance of the Games. “The Games matter for sport, the whole system from calendar to athletes’ preparation shifted a year with all the complexity this represents. The Games matter for society, starting with Japan and the immense efforts which were foreseen with the postponement. Since then, the United Nations, the leaders of the G20, G7 and numerous governments have outlined the importance of sport and the Olympic Games Tokyo 2020 for society at large. While the Games were always an important phenomenon, they matter even more nowadays.” That meant all stakeholders agreeing to hold the Games in the same time slot in 2021 – a decision requiring IFs to adjust their sports calendars accordingly. World Athletics and FINA, for example, agreed to move their world championships from 2021 to 2022. Other  “It took hard work, absolute dedication, thorough planning and execution” CHRISTOPHE DUBI  sports adapted their schedules and RightsHolding Broadcasters (RHBs) also signed on to the new dates: 23 July to 8 August for the Olympic Games and 24 August to 5 September for the Paralympic Games. The heavy ﬁnancial and economic impact of the postponement stretched across the Olympic Movement, striking the smaller IFs, which rely on Games revenues for survival, particularly hard. In response, in May 2020, the IOC announced a ﬁnancial package of up to USD 800 million to cover increased costs associated with the 12-month delay. This included an aid package of USD 150 million in loans and payments to help NOCs, IFs and other organisations to continue their sports, their activities and their support to athletes. Then came one of the biggest challenges of all: ensuring that all the arenas and facilities lined up for the Games in 2020 would be available again in 2021. In a major breakthrough, Tokyo organisers announced to the 136th IOC Session in July that they had succeeded in re-securing all 43 competition venues for the Games, as well as the Olympic Village, International Broadcast Centre (IBC) and Main Press Centre (MPC). Private developers selling the Village apartments had  to agree to delay access to residents by a year, while the Tokyo Big Sight exhibition centre, home of the IBC and MPC, had bookings for 2021 that had to be changed. “That was all done without fuss by the Organising Committee and the Tokyo Metropolitan Government,” Coates said. “It was a massive task.” At the same time, the Games’ competition schedule would remain basically the same, with only some minor timing adjustments for operational reasons. The next major task was ﬁnding ways to optimise Games delivery and produce savings, which resulted in the IOC and Japan agreeing on more than 50 measures to “simplify” the Games and cut back on operational costs. Among the measures were: cancelling the team welcoming ceremonies at the Olympic Village; cutting the size of stakeholder delegations by 10-15 per cent; streamlining transportation for various groups; hosting a number of pre-Games meetings online rather than on-site; and scaling back on the overall look and overlay of the venues. Tokyo 2020 also decided to simplify the Opening and Closing Ceremonies, while retaining the Athletesʼ Parade and other traditional elements."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg70.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 70-quote\" style=\"top:790px;left:263px\" src=\"/116/static/_content/70-quote-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg70Anim = new TimelineMax();\n          pg70Anim.staggerFromTo(cOf(\"70-quote\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg70Anim.stop();\n        }\n        ",
    "searchText": "70  Feature: Postponement Lessons  The cost-cutting efforts led to USD 280 million in savings. This was on top of savings already achieved in the years before the pandemic erupted when thanks to Olympic Agenda 2020 and its New Norm, savings had been made of USD 4.3 billion. This was made up of the USD 2.2 billion already saved during the review of the Venue Master Plan and an additional USD 2.1 billion of savings mainly from the operational budget through the New Norm. Coates said the simpliﬁcation measures created a “Tokyo Model’’ that would “become a blueprint that will beneﬁt future Organising Committees for many years to come”. For example, taking delivery of venues later and preparing them in a shorter time resulted in signiﬁcant savings. In the future, opening the Olympic Village later could also be considered, Coates said. In addition, to help face the exceptional circumstances, for the Games, the IOC and Japanese officials agreed to minimise the period of stay in the Village for health reasons, deciding that athletes should arrive ﬁve days before the start of their competition and leave a maximum of two days afterwards. The ﬁnal major decisions related to the postponement involved the coronavirus counter-measures for organising the Games safely amid a continuing pandemic. This centred on the publication of several Playbooks laying out the safety rules and 1 Protective measures at the Tokyo Stadium during the rugby sevens test event in April 2021. 2 John Coates, IOC Vice-President and Chair of the IOC Coordination Commission for Tokyo 2020.  2  1  protocols for all participants at the Games – including plans for regular COVID-19 testing. As coronavirus infections rose in Japan and other parts of the world, in March this year the Japanese government made the decision to bar overseas spectators from the Games. In addition, the IOC decided to restrict accreditation to the Games to only those with “essential and operational roles”. The IOC, IFs and NOCs have all focused their efforts and programmes only on Games critical activities. Coates said the overall priority was to get “back to basics’’ and cut out the “nice-tohaves”, focusing on the essentials and providing the best conditions for the athletes. “It will be a Games where you go about your business,’’ he said. ‘’For the athletes, it’s about competing. That doesn’t change. Competing against the best, the camaraderie, those things won’t change and this is the core of the Olympic Games.” Dubi said the IOC has gained important insights from the scaling-back process in Tokyo. “Tokyo shows us that by being creative, including in the most mundane of things, such as food and beverage, or  “It will be a Games where you go about your business. For the athletes, it's about competing” JOHN COATES  numbers of cars or space needed, you can simplify things,” he said. “It shows that once you start looking for practical solutions, you won’t stop. What we were forced to do in the context of Tokyo opens the door for the future. I am convinced this is a mindset we all share.” Another lasting lesson may come from the digital engagement efforts in Tokyo. With overseas spectators not allowed, the IOC and RHBs are planning ways to bring the world into the stadiums and the streets of Tokyo to experience the Games as if they were there. ‘’We have upped our game of what the digital offering of Tokyo will be,’’ Dubi said. “People will be pretty excited with the whole digital rendering and I think it is something that will stick in the future as well. I think it is going to be a huge engagement success.” The postponed Tokyo Games have also taught the IOC and the Olympic Movement another valuable long-term lesson: how to deal with a pandemic or other health crisis. “We have to be prepared for the future,” Dubi said. “It could be COVID or it could be something else. You need to have two types of management strands in an organisation: You need people to deliver the baseline operations and you also need an agile team that is able to cope with whatever circumstances are thrown at you.” ■"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg71.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:352px;left:164px;height:15px;width:103px;\">\n        <a href=\"https://intel.com/olympics\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          addContentLinks()\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "Intel has raised the bar for wonderful experiences by accelerating the adoption of new technologies like 5G, artiﬁcial intelligence, immersive media, drones, esports event integrations, and through our silicon solutions to enhance the Olympic Games. Together with other TOP Partners, Intel is integrating technology into many facets of the Olympic Games from infrastructure and operations to athlete performance enabling new levels of interaction, connectivity, and data-rich experiences. Find out more at intel.com/olympics"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg72.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 72-title\" style=\"top:105px;left:44px\" src=\"/116/static/_content/72-title-1.png\">\n        <img class=\"halfScale 72-sub\" style=\"top:208px;left:45px\" src=\"/116/static/_content/72-sub-1.png\">\n        <img class=\"halfScale 72-sub\" style=\"top:284px;left:68px\" src=\"/116/static/_content/72-sub-2.png\">\n        <img class=\"halfScale 72-sub\" style=\"top:396px;left:133px\" src=\"/116/static/_content/72-sub-3.png\">\n        <img class=\"halfScale 72-sub\" style=\"top:459px;left:197px\" src=\"/116/static/_content/72-sub-4.png\">\n        <img class=\"halfScale 72-sub\" style=\"top:519px;left:248px\" src=\"/116/static/_content/72-sub-5.png\">\n        <img class=\"halfScale 72-sub\" style=\"top:598px;left:313px\" src=\"/116/static/_content/72-sub-6.png\">\n        <img class=\"halfScale 72-sub\" style=\"top:732px;left:432px\" src=\"/116/static/_content/72-sub-7.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          if(Publish.isDoublePage){\n            pg72Anim = new TimelineMax();\n            pg72Anim.fromTo(cOf(\"72-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n            .staggerFromTo(cOf(\"72-sub\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.2, \"-=0.3\")\n            .staggerFromTo(cOf(\"73-sub\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.2, \"-=0.2\")\n          } else {\n            pg72Anim = new TimelineMax();\n            pg72Anim.fromTo(cOf(\"72-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n            .staggerFromTo(cOf(\"72-sub\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.2, \"-=0.3\")\n          }\n        }\n\n        function onPageLeave() {\n          pg72Anim.stop();\n        }\n        ",
    "searchText": "72  Feature: Postponement Lessons  Towards Tokyo Olympic Review chronicles the key moments and decisions taken by the IOC and Tokyo 2020 since last year’s historic postponement  2020 MARCH 24 25 30  Tokyo Olympic Games and Paralympic Games postponed to 2021 IOC establishes “Here We Go’’ Task Force and Joint Steering Committee to tackle issues related to the postponement New dates announced: 23 July-8 August 2021 for Olympic Games and 24 August-5 September 2021 for Paralympic Games  APRIL 1  IOC launches #StayStrong digital campaign connecting athletes with people all over the world  MAY 15  IOC sets aside USD 800 million to cover additional costs associated with postponement  JUNE 23  Olympic Day features world's biggest digital Olympic workout introducing half a billion people to the #StayStrong campaign  JULY 15 17  Revised qualiﬁcation systems for each sport approved for postponed Tokyo Games  23  Tokyo marks one-year countdown to rescheduled Games with a ceremony at the Olympic Stadium. IOC launches its #StrongerTogether campaign  Tokyo 2020 announces that all Olympic venues secured and competition schedule conﬁrmed for postponed Games  SEPTEMBER 25  IOC and Tokyo 2020 agree on over 50 measures to simplify Games and reduce costs  28  Tokyo 2020 announces new dates for Olympic Torch Relay in 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 72,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg73.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 73-sub\" style=\"top:591px;left:52px\" src=\"/116/static/_content/73-sub-1.png\">\n        <img class=\"halfScale 73-sub\" style=\"top:683px;left:116px\" src=\"/116/static/_content/73-sub-2.png\">\n        <img class=\"halfScale 73-sub\" style=\"top:208px;left:315px\" src=\"/116/static/_content/73-sub-3.png\">\n        <img class=\"halfScale 73-sub\" style=\"top:721px;left:358px\" src=\"/116/static/_content/73-sub-7.png\">\n        <img class=\"halfScale 73-sub\" style=\"top:586px;left:411px\" src=\"/116/static/_content/73-sub-6.png\">\n        <img class=\"halfScale 73-sub\" style=\"top:382px;left:468px\" src=\"/116/static/_content/73-sub-5.png\">\n        <img class=\"halfScale 73-sub\" style=\"top:264px;left:546px\" src=\"/116/static/_content/73-sub-4.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          if(Publish.isDoublePage){\n          } else {\n            pg73Anim = new TimelineMax();\n            pg73Anim.staggerFromTo(cOf(\"73-sub\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.2, 1)\n          }\n        }\n\n        function onPageLeave() {\n          pg73Anim.stop();\n        }\n        ",
    "searchText": "2021  APRIL 28  IOC launches the second editions of the Tokyo 2020 Playbooks with the version for athletes and team officials  MARCH 10  Thomas Bach re-elected as IOC President for second term to 2025  12  IOC Session unanimously approves new strategic roadmap Olympic Agenda 2020+5  25 26  IOC Executive Board decides that only those with “essential and operational roles” to be granted accreditation to Tokyo Games  FEBRUARY  NOVEMBER 16−18  Olympic Torch Relay begins from Fukushima Prefecture  3  IOC President Thomas Bach makes ﬁrst trip to Tokyo since the postponement  18  IOC releases ﬁrst of several Playbooks outlining safety measures and protocols for stakeholders attending the Olympic Games Tokyo 2020 Hashimoto Seiko appointed new President of Tokyo 2020  DECEMBER 7  IOC and Tokyo 2020 agree on guidelines for minimising athletes’ period of stay in Olympic Village  JANUARY 27  IOC Executive Board decides that 137th IOC Session, originally scheduled to take place in Athens from 10-12 March, will be held virtually due to COVID restrictions"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 73,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg74.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 74-title\" style=\"top:111px;left:44px\" src=\"/116/static/_content/74-title-1.png\">\n        <img class=\"halfScale 74-title\" style=\"top:254px;left:46px\" src=\"/116/static/_content/74-sub-1.png\">\n        <img class=\"halfScale 74-title\" style=\"top:314px;left:51px\" src=\"/116/static/_content/74-sub-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg74Anim = new TimelineMax();\n          pg74Anim.staggerFromTo(cOf(\"74-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg74Anim.stop();\n        }\n        ",
    "searchText": "74  My Games: Donna de Varona  MY GAMES DONNA DE VARONA ROME 1960, TOKYO 1964  MY FIRST GAMES  DONNA DE VARONA WON TWO GOLD MEDALS IN SWIMMING AT THE OLYMPIC GAMES TOKYO 1964, AND HAS SINCE COVERED 18 GAMES AS A TRAILBLAZING, EMMY AWARD-WINNING BROADCASTER. HERE, SHE TALKS TO STEPHEN WILSON ABOUT HER LIFE-CHANGING OLYMPIC EXPERIENCES AND INFLUENTIAL POST-SWIMMING CAREER  I was just 13 years old and the youngest world record-holder at Rome 1960, but sadly my best event (400m individual medley) was not on the Olympic programme for women at the time. I was just ﬁve-feet-two-inches tall and 100 pounds soaking wet, and Italian officials kept shouting at me: “Get off the pool deck, coaches’ daughters are not allowed in the Olympic pool!” I competed in the heats of the 4×100m freestyle relay and helped Team USA qualify for the ﬁnal, where they trounced rivals Australia. Back then, unlike today, preliminary swimmers didn’t receive gold medals. My time in the Olympic Village was magical. I met a shy Cassius Clay, well before the legend changed his name to Muhammad Ali, forged a lifelong friendship with track great Wilma Rudolph, and learned how to dance the “twist’’ from members of the US track team. But perhaps the most impactful memory was from the Opening Ceremony."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 74,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg75.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  Donna de Varona starred as a 17-yearold at the Olympic Games Tokyo 1964.  Issue 116  75"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 75,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg76.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "76  My Games: Donna de Varona  Stuck behind much taller athletes, I was straining to catch a glimpse of the torchbearer entering the stadium to light the cauldron when, suddenly, I felt myself being lifted up and up onto the shoulders of a tall man behind me. It was US basketball star Walt Bellamy. This was 1960, when a black man risked his life if he touched a white woman. Yet within this safe, diverse Olympic community, Walt reached out to me without fear of reprisal. In the mid-1960s during the height of the civil rights era, Walt and I would work together on a programme for American inner-city youths. My whole world expanded after my experience in Rome. I saw the world differently after that.  ROAD TO TOKYO After Rome, as the reigning world recordholder in the 400m individual medley, I had to continually improve to stay ahead of my rivals. Expectations mounted as my successes were featured on the ABC network show, “Wide World of Sports”. In appearing on the cover of Sports Illustrated for the ﬁrst time aged 14, I was a target. In 1961, a small teenage swimming delegation was invited to Japan for an Olympic promotional tour. As we travelled throughout the country, we saw signs of the impact and vestiges of World War II. The still-visible bullet holes that were embedded on the façade of the Imperial Palace greeted us upon check-in to our nearby hotel. But much to our delight, we discovered how much the Japanese loved our sport when we took part in swimming exhibitions in 25m pools surrounded by rice paddies. I swam in fun 200m races on my own against a relay of young Japanese boys. In 1963, Team USA returned to Japan for a pre-Olympic invitational competition. What a difference two years had made in the transformation of a city and country. A sell-out crowd packed the 50m facility in Osaka for the competition. Our team was showered with traditional Japanese gifts including vases, kimonos, high-tech cameras and decorative medals. The generous hospitality demonstrated the compassion and transformative spirit of the Olympic Movement.  1  GOLD MEDAL GAMES Before Tokyo 1964, as I had set some 18 world records and fastest times, many journalists speculated that I would become the deﬁning female swimmer of that era. I appreciated the support of the press but I did not want the expectations of others to undermine what I had already achieved. During the Opening Ceremony, I felt the will to win swelling inside me. Victory was the only option. I won my ﬁrst gold on 15 October, swimming the second leg of the 4×100m freestyle relay with my team-mates Sharon Stouder, Lillian “Pokey” Watson and Kathy Ellis. In beating our rivals Australia, we set a new world record (4:03.8). Much to my relief, I swam a personal best and had the second-fastest time on the team. The relay victory helped ease mounting pressure when two days later I waited to be called to the starting block for the ﬁnal of my signature event, the 400m individual medley. On race day I had a 100-degree temperature, likely stemming from a ﬂu that made its way through the Olympic Village. But this was it, my chance to win individual Olympic gold. Nothing would stop me. Once  the race started, I felt like I was one with the water and truly ﬂoating on air. I led from the start and ﬁnished nearly six seconds ahead of my team-mates in an Olympic record. Myself, Sharon Finneran and Martha Randall scored a clean US sweep of the medals. What made it even more special was looking up and seeing my mum [Martha] and dad [David] in the stands. A championship rower on the University of California eights crew, Dad most likely would have competed in Tokyo in 1940 had the Games not been cancelled because of war. He ended up serving in the Red Cross and was the only ﬁeld director to jump with paratroopers multiple times in combat. Twenty-four years later, here he was in former enemy territory as the house guest of a welcoming Japanese family, watching his daughter win Olympic gold. Only the Olympic Games could have brought these two families together.  1 Donna de Varona interviews US 400m hurdler Edwin Moses at the Olympic Games Los Angeles 1984. 2 She also served as a long-standing member of the IOC Women in Sport Commission."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 76,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg77.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 77-quote\" style=\"top:788px;left:44px\" src=\"/116/static/_content/77-quote-1.png\">\n        <h1 id=\"77-no\" class=\"abs 77-no ohr\" style=\"left: 617px; top: 266px; font-size: 4.5em; color: #FFF; padding: 0px; margin: 0px; opacity: 1;\" data-number='{\"to\": 2 }'></h1>\n        <h1 id=\"77-no\" class=\"abs 77-no ohr\" style=\"left: 582px; top: 473px; font-size: 4.5em; color: #FFF; padding: 0px; margin: 0px; opacity: 1;\" data-number='{\"to\": 13 }'></h1>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg77Anim = new TimelineMax();\n          pg77Anim.staggerFromTo(cOf(\"77-quote\"), 0.8, {opacity:0, x:30}, {opacity:1, x:0, ease: Power4.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"77-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"77-no\")[0]);}}, 1.3)\n          .fromTo(cOf(\"77-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"77-no\")[1]);}}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg77Anim.stop();\n          resetNumbers(\"77-no\");\n        }\n        ",
    "searchText": "Olympic Review  Issue 116  FACT FILE MY POST-OLYMPIC CAREER I can still recall walking back after my ﬁnal event in Tokyo, thinking: “I’ve realised my dream, but what’s next?” I knew that if I wanted to attend college, I would have to retire. Sports scholarships were not offered to female athletes of my generation, and lucrative endorsement deals for popular female Olympians did not exist. Fortunately, six months after the Olympic Games Tokyo 1964, when I reached out to ABC producer Chuck Howard and told him, “The only way I can bear to retire is if ABC hires me to work as an expert on swimming,” he came through. A few weeks later, at age 17, work permit in hand, I made my debut on “Wide World of Sports” covering the men’s national championships, becoming the youngest sportscaster – and one of the ﬁrst women – to appear on a national network. During my broadcasting career I used my media platform to contribute to women in sport in other ways. In the mid-1960s US Vice President Hubert Humphrey responded to a proposal I had written calling for Peace Corps of Sport in America. Subsequently “Operation Champ” was created. For two years, professional and Olympic athletes toured the country delivering motivational talks and clinics to thousands of inner-city youths during the years of civil unrest across the United States. Often summoned to testify in Congress to request funding for the programme, I continued to work on other legislative initiatives related to education, sport and health. As a US Senate consultant, I helped support and protect Title IX, which in 1972 made it possible for women to participate in high school and college sports as well as accept scholarships. As a President Ford appointee, I was part of a commission that, through the enactment of the Amateur Sports Act of 1978, restructured the US Olympic community. As a President Clinton appointee, I helped with the establishment of the World Anti-Doping Agency (WADA) and the US Anti-Doping Agency (USADA).  “My whole world expanded after my experience in Rome. I saw the world differently after that” DONNA DE VARONA  However, perhaps my most rewarding experience was serving as the chair of the successful 1999 FIFA Women’s World Cup in the USA. In 1974 the Women’s Sports Foundation was created. As its ﬁrst President, I worked to establish a powerful home for women athletes who were and continue to be underserved by the male-dominated world of sport organisations. For decades I served on the IOC Women in Sport Commission. I am currently a member of the IOC Communications Commission and was recently elected to the US Olympic & Paralympic Committee (USOPC). I never dreamed my entire life would be anchored in sport.  TOKYO 2020 iN 2021 I had hoped to return to Tokyo this summer for the postponed Olympic Games. I’m disappointed, as are so many others who cannot attend, but ensuring the safety and security of the Japanese people and of the Games during the continuing pandemic is essential. I believe Japan and the world need these Games. They will once again showcase what is possible when more than 200 countries embrace the promise of the Olympic Movement and the athletes, who have struggled to keep their dreams alive, to bring inspiration and hope back to the world. ■  Competed for  USA  2  GOLD MEDALS in Olympic swimming: 400m individual medley (Tokyo 1964) 4×100m freestyle relay (Tokyo 1964)  13  YEARS OLD when making Olympic debut  HONOURS Recipient of IOC Olympic Order in silver  2  Elected to the USOPC Board of Directors in 2020"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 77,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg78.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 78-title\" style=\"top:98px;left:44px\" src=\"/116/static/_content/78-title-1.png\">\n        <img class=\"halfScale 78-title\" style=\"top:163px;left:44px\" src=\"/116/static/_content/78-sub-1.png\">\n\n        <div class=\"addContentLink\" style=\"top: 290px;left: 41px;height: 133px;width: 89px;\">\n          <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/210614/japan-through-the-lens-of-the-tokyo-olympics-ed-by-barbara-holthus-et-al\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top: 290px;left: 260px;height: 133px;width: 117px;\">\n          <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/211018/the-history-of-the-olympic-games-faster-higher-stronger-an-official-publication-of-the-olympic-found\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top: 290px;left: 479px;height: 133px;width: 97px;\">\n          <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/207018/sport-values-in-every-classroom-teaching-respect-equity-and-inclusion-to-8-12-year-old-students-unes\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top: 833px;left: 334px;height:13px;width: 208px;\">\n          <a href=\"https://www.olympics.com/ioc/olympic-studies-centre\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top: 832px;left: 183px;height: 13px;width: 148px;\">\n          <a href=\"mailto:studies.centre@olympic.org\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top: 845px;left: 245px;height:13px;width: 119px;\">\n          <a href=\"https://www.facebook.com/olympicstudiescentre\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top: 846px;left: 368px;height: 13px;width: 114px;\">\n          <a href=\"https://library.olympics.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg78Anim = new TimelineMax();\n          pg78Anim.staggerFromTo(cOf(\"78-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg78Anim.stop();\n          removeContentLinks()\n        }\n        ",
    "searchText": "78  Olympic Studies  OLYMPiC STUDiES The latest book reviews from the IOC Olympic Studies Centre – your source of Olympic knowledge  JAPAN THROUGH THE LENS OF THE TOKYO OLYMPICS  THE HISTORY OF THE OLYMPIC GAMES:  SPORT VALUES IN EVERY CLASSROOM:  The Olympic Games Tokyo 2020 are serving as a catalyst for important issues in contemporary Japanese society and have already left a considerable legacy for the country, despite being postponed by one year. This open-access book written by leading experts on Japanese sport and society provides a fascinating window into the host country as a whole, not just the mega-event itself. It covers a diverse range of topics and offers hidden insights and new perspectives on the Games. Taking this multitude of facets into account shows how, in the run-up to the Olympic Games, Japan is shaping and being shaped by Tokyo 2020.  FASTER, HIGHER, STRONGER  TEACHING RESPECT, EQUITY AND INCLUSION TO 8-12-YEAR-OLD STUDENTS  AUTHORS: Barbara Holthus, Isaac Gagné,  AUTHOR: International Olympic Committee PUBLiSHED BY: Welbeck Publishing Group  Wolfram Manzenreiter, Franz Waldenberger PUBLiSHED BY: Routledge, 2020, ISBN 9780367469573, 143 pages, in English.  Published in association with the IOC, The History of the Olympic Games: Faster, Higher, Stronger brings the glorious history of the Olympic Games to life. Beginning in Ancient Greece and covering every edition of the modern Games, it showcases the most spectacular achievements to have graced the Olympic stage. Featuring over 200 photographs and including rare documents and artefacts from the archives of the Olympic Museum, this fascinating volume charts the absorbing and exemplary history of the Olympics through a wealth of sporting achievement.  Limited, 2021, ISBN 9781787394049, 160 pages, in English.  The IOC has launched this free toolkit to help teach 8-12-year-olds around the world some of the core values that are synonymous with sport, such as respect, fairness and inclusion, while encouraging movement-based activities. The toolkit can be used by teachers of any subject and anyone with a connection to young people. It is available in English, French and Spanish.  AUTHORS: UNESCO, Olympic Foundation for Culture and Heritage, Agitos Foundation, WADA, International Council of Sport Science and Physical Education, International Fair Play Committee PUBLiSHED BY: UNESCO, OFCH, Agitos Foundation, WADA, ICSSPE/CIEPSS, CIFP, 2019, ISBN 9789231003516, 186 pages, in English.  FIND OUT MORE For historical, factual and academic research, library resources and book loans, visit the Olympic World Library or contact us. studies.centre@olympic.org olympics.com/ioc/olympic-studies-centre OlympicStudiesCentre library.olympics.com"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 78,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg79.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 79,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg80.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 80-title\" style=\"top:98px;left:44px\" src=\"/116/static/_content/80-title-1.png\">\n        <img class=\"halfScale 80-title\" style=\"top:163px;left:44px\" src=\"/116/static/_content/80-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg80Anim = new TimelineMax();\n          pg80Anim.staggerFromTo(cOf(\"80-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg80Anim.stop();\n        }\n        ",
    "searchText": "80  Obituaries  OBITUARIES We remember Olympians and ﬁ gures from the Olympic Movement who have passed away  FLOR ISAVA FONSECA IOC Honorary Member and trailblazer who made history in 1981 as one of the ˇrst two women elected as IOC Members Flor Isava Fonseca, the gender equality pioneer who blazed a trail for women in the Olympic Movement, has died at the age of 99. Fonseca was one of the ﬁrst two women elected as an IOC Member in 1981, and the ﬁrst female IOC Executive Board member, serving from 1990 to 1994. She was also an Olympian, having represented Venezuela in equestrian in 1956.  DAVID DUSHMAN David Dushman, the legendary fencing coach and last living liberator of the Auschwitz concentration camp, has died at the age of 98. Dushman became coach of elite Russian club Spartak Moscow, and from 1952 to 1988, coached the women's national team of the Soviet Union, training many Olympic champions. Until the age of 94, he was still training fencers almost daily at his club in Munich. Dushman was a major in the Russian Army during the Second World War, and on 27 January 1945, he was one of the soldiers who came to liberate those imprisoned in the Auschwitz concentration camp.  WALTHER TRÖGER Walther Tröger, IOC Honorary Member, has died at the age of 91. Tröger’s remarkable career as a sports administrator was marked by his successful commitment to shaping sport in Germany for several decades. He served as Secretary General of the German National Olympic Committee between 1970 and 1992, and as President for 10 years until 2002. Tröger was Chef de Mission at the Olympic Winter Games eight times between 1976 and 2002, while during the Olympic Games Munich 1972, his role as Mayor of the Olympic Village led to his involvement in the negotiations with the group that took Israeli athletes hostage. He went on to serve as IOC Sports Director between 1983 and 1990, before becoming an IOC Member in 1989 and an Honorary Member in 2010.  FERNANDO LiMA BELLO GÜNTHER HEiNZE  LEE KUN-HEE  IOC Honorary Member Günther Heinze has passed away at the age of 97. Heinze was a highly engaged IOC Member who paved the way for the reorganisation of sport in Germany after the reuniﬁcation in 1990 by offering his resignation as an IOC Member. A civil servant with a political science degree, Mr Heinze was particularly involved in basketball, and was a referee for the International Basketball Federation (FIBA) from 1952 to 1956, among many more roles in sports administration. He became an IOC Honorary Member in 1992.  Lee Kun-hee, who was Chairman of the Samsung Group between 1987 and 2020, has passed away aged 78. Lee led the growth of Samsung from a local business in the Republic of Korea to a global technology leader and a Worldwide Olympic Partner. Lee, who also practised wrestling, was elected as an IOC Member in 1996, where he joined the Cultural (1997) and Finance (1998-1999) Commissions. He became an IOC Honorary Member in 2017, and was a recipient of the Olympic Order in 1991.  Olympian and sports administrator Fernando Lima Bello has died aged 89. Lima Bello competed for Portugal in sailing at the Olympic Games Mexico City 1968 and Munich 1972. He later served as Chairman of the Portuguese Olympic Committee, and as an IOC Member from 1989 until 2010, when he became an IOC Honorary Member.  In addition to those mentioned here, the IOC wishes to express its condolences to the families and loved ones of all those who have passed away in the last year."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 80,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg81.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  81  Issue 116  JOHN KONRADS  KOGA TOSHiHiKO Japanese judoka who won gold in the menís 71kg event at the Olympic Games Barcelona 1992 and went on to become an inspirational coach Koga Toshihiko, a three-time Olympian in judo and double Olympic medallist, has passed away aged 53. In his second appearance at the Games, at Barcelona 1992, Koga won gold in the men’s 71kg event, following with silver four years later  in Atlanta in the 78kg event. He also won three world championship titles between 1989 and 1995. He served as a coach for Japan’s women’s national judo team after retiring in 2000, and helped Tanimoto Ayumi win gold at Athens 2004.  Australian swimmer and Olympic champion John Konrads has died aged 78. Konrads won three medals at the Olympic Games Rome 1960, including gold in the 1500m freestyle. Following his retirement, he became a swimming coach and later assisted with the winning bid for the Olympic Games Sydney 2000. Konrads was inducted into the Sport Australia Hall of Fame.  CONN FiNDLAY Conn Findlay, the American four-time Olympian who won Olympic medals in rowing and sailing, has passed away at the age of 90. He won two Olympic gold medals in rowing, in the men’s coxed pair event, at Melbourne 1956 and Tokyo 1964, adding a bronze in the same event at Rome 1960. After a 12-year Olympic hiatus, Findlay then made his comeback in sailing at Montreal 1976, winning bronze in the men’s tempest class event.  DiÁNA IGALY  URSULA HAPPE  LEE EVANS  Ursula Happe, the swimmer who won a gold medal in the women's 200m breaststroke at the Olympic Games Melbourne 1956, has died at the age of 94. Happe was elected German sportswoman of the year in both 1954 and 1956 and was awarded the Silver Laurel Leaf for her achievements, the highest award for sporting performance in Germany.  Lee Evans, the American sprinter and double Olympic champion, has passed away at the age of 74. Evans won his two gold medals at the Olympic Games Mexico City 1968, where he broke the world record both in the 400m and as part of the US 4×400m relay team. After his retirement from competition, Evans worked for the United Nations and coached national teams in Nigeria and Saudi Arabia.  HÅKON BRUSVEEN Norwegian cross-country skier Håkon Brusveen has died at the age of 93. Brusveen was a two-time Olympian who won gold in the men’s 15km event at the Olympic Winter Games Squaw Valley 1960, where he also added a silver medal in the 4×10km relay. He later became a sports commentator for Norwegian broadcaster NRK.  Diána Igaly, the Hungarian shooter and two-time Olympic medallist, has passed away aged 56. At the Olympic Games Sydney 2000, Igaly took bronze in the women’s skeet event, and won gold in Athens four years later. She also won four world and six European championship titles."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 81,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg82.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 82-title\" style=\"top: 101px;left: 43px;\" src=\"/116/static/_content/82-title-1.png\">\n        <img class=\"halfScale 82-sub-1\" style=\"top: 105px;left: 309px;\" src=\"/116/static/_content/82-sub-1.png\">\n\n        <img class=\"halfScale 82-sub-2\" style=\"top: 203px;left: 65px;\" src=\"/116/static/_content/82-sub-2.png\">\n        <img class=\"halfScaleC 82-icon-1\" style=\"top: 214px;left: 59px;\" src=\"/116/static/_content/82-icon-1.png\">\n        <img class=\"halfScale 82-sub-3\" style=\"top: 328px;left: 59px;\" src=\"/116/static/_content/82-sub-3.png\">\n        <img class=\"halfScaleC 82-icon-2\" style=\"top: 318px;left: 30px;\" src=\"/116/static/_content/82-icon-2.png\">\n        <h1 id=\"82-no\" class=\"abs 82-no ohr\" style=\"left: 115px;top: 406px;font-size: 1.4em;font-weight: 400;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\" data-number='{\"to\": 58, \"append\": \"%\" }'></h1>\n        <img class=\"halfScale 82-sub-4\" style=\"top: 476px;left: 64px;\" src=\"/116/static/_content/82-sub-4.png\">\n        <img class=\"halfScaleC 82-icon-3\" style=\"top: 499px;left: 59px;\" src=\"/116/static/_content/82-icon-3.png\">\n        <img class=\"halfScale 82-sub-5\" style=\"top: 613px;left: 59px;\" src=\"/116/static/_content/82-sub-5.png\">\n\n        <img class=\"halfScale 82-line-1\" style=\"top: 261px;left: 228px;\" src=\"/116/static/_content/82-line-1.png\">\n        <img class=\"halfScaleC 82-green-1\" style=\"top: 32px;left: 27px;\" src=\"/116/static/_content/82-green-1.png\">\n\n        <img class=\"halfScale 82-sub-6\" style=\"top: 213px;left: 267px;\" src=\"/116/static/_content/82-sub-6.png\">\n        <img class=\"halfScale 82-sub-7\" style=\"top: 238px;left: 265px;\" src=\"/116/static/_content/82-sub-7.png\">\n        <img class=\"halfScaleC 82-icon-4\" style=\"top: 202px;left: 211px;\" src=\"/116/static/_content/82-icon-4.png\">\n        <img class=\"halfScale 82-line-2\" style=\"top: 313px;left: 387px;\" src=\"/116/static/_content/82-line-2.png\">\n        <img class=\"halfScale 82-sub-8\" style=\"top: 227px;left: 440px;\" src=\"/116/static/_content/82-sub-8.png\">\n        <h1 id=\"82-no\" class=\"abs 82-no ohr\" style=\"left: 456px;top: 254px;font-size: 1.4em;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\" data-number='{\"to\": 5000, \"comma\": true}'></h1>\n        <img class=\"halfScaleC 82-icon-5\" style=\"top: 277px;left: 426px;\" src=\"/116/static/_content/82-icon-5.png\">\n        <img class=\"halfScale 82-line-3\" style=\"top: 313px;left: 516px;\" src=\"/116/static/_content/82-line-3.png\">\n        <img class=\"halfScaleC 82-icon-6\" style=\"top: 229px;left: 539px;\" src=\"/116/static/_content/82-icon-6.png\">\n        <h1 id=\"82-no\" class=\"abs 82-no ohr\" style=\"left: 558px;top: 325px;font-size: 1.4em;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\" data-number='{\"to\": 24.5, \"decimals\": 1, \"append\": \" TONNES\" }'></h1>\n        <img class=\"halfScale 82-sub-9\" style=\"top: 350px;left: 559px;\" src=\"/116/static/_content/82-sub-9.png\">\n        <img class=\"halfScale 82-line-4\" style=\"top: 412px;left: 266px;\" src=\"/116/static/_content/82-line-4.png\">\n        <img class=\"halfScaleC 82-icon-7\" style=\"top: 391px;left: 235px;\" src=\"/116/static/_content/82-icon-7.png\">\n        <h1 id=\"82-no\" class=\"abs 82-no ohr\" style=\"left: 290px;top: 455px;font-size: 1.9em;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\" data-number='{\"to\": 99, \"append\": \"%\" }'></h1>\n        <img class=\"halfScale 82-sub-10\" style=\"top: 462px;left: 357px;\" src=\"/116/static/_content/82-sub-10.png\">\n        <img class=\"halfScaleC 82-icon-8\" style=\"top: 391px;left: 429px;\" src=\"/116/static/_content/82-icon-8.png\">\n        <h1 id=\"82-no\" class=\"abs 82-no ohr\" style=\"left: 556px;top: 440px;font-size: 1.4em;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\" data-number='{\"to\": 65, \"append\": \"%\" }'></h1>\n        <img class=\"halfScale 82-sub-11\" style=\"top: 463px;left: 556px;\" src=\"/116/static/_content/82-sub-11.png\">\n\n        <img class=\"halfScale 82-sub-12\" style=\"top: 552px;left: 253px;\" src=\"/116/static/_content/82-sub-12.png\">\n        <img class=\"halfScaleC 82-icon-9\" style=\"top: 567px;left: 225px;\" src=\"/116/static/_content/82-icon-9.png\">\n        <img class=\"halfScale 82-sub-13\" style=\"top: 589px;left: 342px;\" src=\"/116/static/_content/82-sub-13.png\">\n        <img class=\"halfScaleC 82-icon-10\" style=\"top: 554px;left: 473px;\" src=\"/116/static/_content/82-icon-10.png\">\n        <h1 id=\"82-no\" class=\"abs 82-no ohr\" style=\"left: 590px;top: 576px;font-size: 1.3em;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\" data-number='{\"to\": 26000, \"comma\": true }'></h1>\n        <img class=\"halfScale 82-sub-14\" style=\"top: 599px;left: 590px;\" src=\"/116/static/_content/82-sub-14.png\">\n\n        <img class=\"halfScale 82-line-5\" style=\"top: 655px;left: 44px;\" src=\"/116/static/_content/82-line-5.png\">\n\n        <img class=\"halfScale 82-sub-15\" style=\"top: 673px;left: 45px;\" src=\"/116/static/_content/82-sub-15.png\">\n        <img class=\"halfScaleC 82-icon-11\" style=\"top: 678px;left: 29px;\" src=\"/116/static/_content/82-icon-11.png\">\n        <h1 id=\"82-no\" class=\"abs 82-no ohr\" style=\"left: 82px;top: 792px;font-size: 1.4em;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\" data-number='{\"to\": 30, \"append\": \"%\" }'></h1>\n        <img class=\"halfScale 82-sub-16\" style=\"top: 816px;left: 45px;\" src=\"/116/static/_content/82-sub-16.png\">\n        <img class=\"halfScale 82-line-6\" style=\"top: 748px;left: 142px;\" src=\"/116/static/_content/82-line-6.png\">\n        <img class=\"halfScaleC 82-icon-12\" style=\"top: 620px;left: 171px;\" src=\"/116/static/_content/82-icon-12.png\">\n        <h1 id=\"82-no\" class=\"abs 82-no ohr\" style=\"left: 269px;top: 815px;font-size: 1.4em;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\" data-number='{\"to\": 25, \"append\": \"%\" }'></h1>\n        <img class=\"halfScale 82-sub-17\" style=\"top: 840px;left: 245px;\" src=\"/116/static/_content/82-sub-17.png\">\n        <img class=\"halfScale 82-line-7\" style=\"top: 747px;left: 351px;\" src=\"/116/static/_content/82-line-7.png\">\n        <img class=\"halfScaleC 82-icon-13\" style=\"top: 621px;left: 334px;\" src=\"/116/static/_content/82-icon-13.png\">\n        <h1 id=\"82-no\" class=\"abs 82-no ohr\" style=\"left: 431px;top: 815px;font-size: 1.4em;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\" data-number='{\"to\": 27, \"append\": \"%\" }'></h1>\n        <img class=\"halfScale 82-sub-18\" style=\"top: 840px;left: 409px;\" src=\"/116/static/_content/82-sub-18.png\">\n        <img class=\"halfScale 82-line-8\" style=\"top: 683px;left: 507px;\" src=\"/116/static/_content/82-line-8.png\">\n        <img class=\"halfScaleC 82-icon-14\" style=\"top: 621px;left: 494px;\" src=\"/116/static/_content/82-icon-14.png\">\n        <img class=\"halfScale 82-sub-19\" style=\"top: 819px;left: 572px;\" src=\"/116/static/_content/82-sub-19.png\">\n        <h1 id=\"82-no\" class=\"abs 82-no ohr\" style=\"left: 592px;top: 826px;font-size: 1.4em;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\" data-number='{\"to\": 30, \"append\": \"%\" }'></h1>\n      \n        <div class=\"addContentLink\" style=\"top: 200px;left: 60px;height: 22px;width: 135px;\">\n          <a href=\"https://www.youtube.com/watch?v=674_AuH_jkw\" target=\"_blank\"></a>\n        </div>\n\n        ",
    "script": "\n        function onPageEnter() {\n          pg82Anim = new TimelineMax();\n          pg82Anim.fromTo(cOf(\"82-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"82-sub-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-2\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-1\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-3\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-2\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[0]);}}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-4\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-3\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-5\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-line-1\"), 0.3, {opacity:0, y:60}, {opacity:1, y:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-green-1\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n          .fromTo(cOf(\"82-sub-6\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-7\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-4\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-line-2\"), 0.3, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-8\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.2\")\n          .fromTo(cOf(\"82-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[1]);}}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-5\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-line-3\"), 0.3, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-6\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n          .fromTo(cOf(\"82-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[2]);}}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-9\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-line-4\"), 0.3, {opacity:0, y:-60}, {opacity:1, y:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-7\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n          .fromTo(cOf(\"82-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[3]);}}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-10\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-8\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[4]);}}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-11\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-12\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-9\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-13\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-10\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[5]);}}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-14\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-line-5\"), 0.3, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-15\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-11\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[6]);}}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-16\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-line-6\"), 0.3, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-12\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n          .fromTo(cOf(\"82-no\")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[7]);}}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-17\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-line-7\"), 0.3, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-13\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n          .fromTo(cOf(\"82-no\")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[8]);}}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-18\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-line-8\"), 0.3, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-14\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n          .fromTo(cOf(\"82-sub-19\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-no\")[9], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[9]);addContentLinks();}}, \"-=0.4\")\n          \n        }\n\n        function onPageLeave() {\n          pg82Anim.stop();\n          resetNumbers(\"82-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": "82  Fast Facts  FAST FACTS A CLEANER GAMES  Key facts and ﬁ gures about how the Olympic Games Tokyo 2020 will be delivered in a sustainable way while providing a safe environment for all  RECYCLING The Japanese people have donated:  Recycled electronics which have been made into  5,000  Olympic and Paralympic medals  24.5 TONNES  Zero-emission hydrogen will light the Olympic cauldron and Relay torches  of household plastic waste which have been recycled to create 98 Olympic and Paralympic podiums  58% of the facilities used at Tokyo 2020 will be existing or temporary to cut costs and reduce emissions by minimising construction  99%  of procured goods will be recycled or reused  65% of waste generated during the Games will be reused or recycled by Tokyo 2020  OLYMPIC VILLAGE Olympic Village Plaza uses wood from prefectures that will be transformed into public facilities after the Games  Venues will use renewable electricity from biomass and solar power  26,000 beds made almost entirely of recycled cardboard  BROADCASTING  30%  smaller broadcast footprint than Rio 2016  25% smaller International  27% fewer broadcasters  ... While producing  Broadcast Centre  present  more content  30%"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 82,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg83.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "e-Palette On-Demand, Customizable, Self-Driving Platform of the Future  I F YO U C A N D R E A M IT, IT C A N B E IT."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 83,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg84.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-199016370-2',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "NZMO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pg37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S4/L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U2l4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6ic":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WN8W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQhR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zf2O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eJtY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i9d8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tGyY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uDJ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ab5780c46ed3c6a25781.js